// Generated from the visible Cloudflare panel strings. Runtime code uses this static dictionary only; no translation API is called in the browser.
export type PanelLocale = "tr" | "en" | "de";

export const panelTranslations: Record<PanelLocale, Record<string, string>> = {
  "tr": {
    "· stok": "· stoklamak",
    "100 takip senkronla": "100 takip senkronla",
    "194 mevcut, 92 kısmi, 15 eksik": "194 mevcut, 92 kısmi, 15 eksik",
    "30.05.2026 Kenpost Version 2 geçişi": "30.05.2026 Kenpost Version 2 geçişi",
    "AboutYou adı": "AboutYou adı",
    "aç": "aç",
    "Açık olduğunda girişte e-posta doğrulama kodu istenir.": "Açık olduğunda girişte e-posta doğrulama kodu istenir.",
    "Açık siparişler": "Açık siparişler",
    "Açıklama": "Açıklama",
    "Admin": "Admin",
    "Admin destek modu:": "Admin destek modu:",
    "Admin fatura düzenleme": "Admin fatura düzenleme",
    "Admin panele dön": "Admin panele dön",
    "Admin paneli": "Admin paneli",
    "Admin profil ve şifre ayarları.": "Admin profil ve şifre ayarları.",
    "Admin URL": "Yönetici URL'si",
    "Admin, müşteri ve alt müşteri rolleri ayrıldı": "Admin, müşteri ve alt müşteri rolleri ayrıldı",
    "Admin, müşteriye birden fazla etiket ürününü tek işlemde tanımlar; her satır ayrı ürün olarak faturaya yazılır.": "Admin, müşteriye birden fazla etiket ürününü tek işlemde tanımlar; her satır ayrı ürün olarak faturaya yazılır.",
    "Adobe PDF": "AdobePDF",
    "Adres 1": "Adres 1",
    "Adres 2": "Adres 2",
    "Yazdığım adresle devam et": "Yazdığım adresle devam et",
    "Adres kaynağı": "Adres kaynağı",
    "Adres kaynağı belirsiz": "Adres kaynağı belirsiz",
    "Affiliate bilgileri yükleniyor": "Affiliate bilgileri yükleniyor",
    "Affiliate hesapları": "Affiliate hesapları",
    "Affiliate linkinizle gelen müşteriler ve kullanım başına oluşan komisyonlar.": "Affiliate linkinizle gelen müşteriler ve kullanım başına oluşan komisyonlar.",
    "Affiliate profilleri": "Affiliate profilleri",
    "Affiliate programı": "Affiliate programı",
    "Affiliate tahakkuk ve ödeme hareketleri.": "Affiliate tahakkuk ve ödeme hareketleri.",
    "Affiliate ve kazançlar": "Affiliate ve kazançlar",
    "Ağırlığa göre otomatik etiket": "Ağırlığa göre otomatik etiket",
    "Ağırlık": "Ağırlık",
    "Ağırlık aralığı": "Ağırlık aralığı",
    "Aktif etiket ürünü bulunamadı. Önce etiket ürünü tanımlayın veya ürünü aktif hale getirin.": "Aktif etiket ürünü bulunamadı. Önce etiket ürünü tanımlayın veya ürünü aktif hale getirin.",
    "Aktif fiyat ve stok bilgileri satın alma ekranında gösterilir.": "Aktif fiyat ve stok bilgileri satın alma ekranında gösterilir.",
    "Aktif hesap": "Aktif hesap",
    "Aktif kurallar": "Aktif kurallar",
    "Aktif ve pasif planlar.": "Aktif ve pasif planlar.",
    "Aktiflik, e-posta, mağaza ve etiket bakiyesi kontrolü.": "Aktiflik, e-posta, mağaza ve etiket bakiyesi kontrolü.",
    "alıcı": "alıcı",
    "Alıcı": "Alıcı",
    "Alıcı adı": "Alıcı adı",
    "Alıcı ve adres": "Alıcı ve adres",
    "Alt müşteri": "Alt müşteri",
    "Alt müşteri hesaplarını, erişim durumlarını ve son giriş hareketlerini yönetin.": "Alt müşteri hesaplarını, erişim durumlarını ve son giriş hareketlerini yönetin.",
    "Alt müşteriler": "Alt müşteriler",
    "Altı aydan eski, kullanılmamış ve stoktan düşürülmüş etiketler.": "Altı aydan eski, kullanılmamış ve stoktan düşürülmüş etiketler.",
    "Amazon bağlantısını server link akışıyla başlatın; siparişler Shopify kaynak senkronundan alınır.": "Amazon bağlantısını server link akışıyla başlatın; siparişler Shopify kaynak senkronundan alınır.",
    "Amazon bağlantısını yönet": "Amazon bağlantısını yönet",
    "Amazon mağaza adı": "Amazon mağaza adı",
    "Amazon mağazası bağla": "Amazon mağazası bağla",
    "Amazon onay linkini aç": "Amazon onay linkini aç",
    "Amazon yetkilendirmeyi başlat": "Amazon yetkilendirmeyi başlat",
    "Etsy bağlantısını server link akışıyla başlatın; siparişler Shopify kaynak senkronundan alınır.": "Etsy bağlantısını server link akışıyla başlatın; siparişler Shopify kaynak senkronundan alınır.",
    "Etsy mağaza adı": "Etsy mağaza adı",
    "Etsy mağazası bağla": "Etsy mağazası bağla",
    "Etsy onay linkini aç": "Etsy onay linkini aç",
    "Etsy yetkilendirmeyi başlat": "Etsy yetkilendirmeyi başlat",
    "Sistem şu an meşgul. Başka bir Amazon/Etsy bağlantısı çalışıyor; birkaç dakika sonra tekrar deneyin.": "Sistem şu an meşgul. Başka bir Amazon/Etsy bağlantısı çalışıyor; birkaç dakika sonra tekrar deneyin.",
    "Ana mağaza": "Ana mağaza",
    "API anahtarı": "API anahtarı",
    "API kullanıcı": "API kullanıcı",
    "API şifre": "API şifre",
    "Ara servis": "Ara servis",
    "Arama ve durum filtresi aktif": "Arama ve durum filtresi aktif",
    "Atanmış etiket kaynakları.": "Atanmış etiket kaynakları.",
    "Atanmamış": "Atanmamış",
    "ayrı listeyi aç": "ayrı listeyi aç",
    "Ayrıştır": "Ayrıştır",
    "Ayrım": "Ayrım",
    "Bağla": "Bağla",
    "Bağlamak istediğiniz satış kanalını seçin.": "Bağlamak istediğiniz satış kanalını seçin.",
    "Bağlantı": "Bağlantı",
    "Bağlantı başlat": "Bağlantı başlat",
    "Bağlantı bilgileri": "Bağlantı bilgileri",
    "Bağlantı bilgileri güvenli şekilde saklanır. Gizli alanlar gösterilmez; yeni değer girilirse güncellenir, boş bırakılırsa mevcut değer korunur.": "Bağlantı bilgileri güvenli şekilde saklanır. Gizli alanlar gösterilmez; yeni değer girilirse güncellenir, boş bırakılırsa mevcut değer korunur.",
    "Bağlantı durumu": "Bağlantı durumu",
    "Bağlantı modu (connector/ip)": "Bağlantı modu (connector/ip)",
    "Bağlantıyı kapat": "Bağlantıyı kapat",
    "Bağlantıyı tamamla": "Bağlantıyı tamamla",
    "Bağlantıyı test et": "Bağlantıyı test et",
    "Bağlı mağaza yok.": "Bağlı mağaza yok.",
    "Bağlı mağazalar": "Bağlı mağazalar",
    "Bağlı satış kanalları ve entegrasyon özeti.": "Bağlı satış kanalları ve entegrasyon özeti.",
    "Bakım penceresinde tekrar çalışacak": "Bakım penceresinde tekrar çalışacak",
    "Bakım penceresinde yeniden import": "Bakım penceresinde yeniden import",
    "Başarı oranı": "Başarı oranı",
    "Başarılı": "Başarılı",
    "Başlamadı": "Başlamadı",
    "Başlangıç": "Başlangıç",
    "Başlangıç durumu yükleniyor": "Başlangıç durumu yükleniyor",
    "Başlangıç şifresi": "Başlangıç şifresi",
    "Baz fiyat": "Baz fiyat",
    "Baz fiyat:": "Baz fiyat:",
    "Bekleyen ödeme": "Bekleyen ödeme",
    "Bilinmiyor": "Bilinmiyor",
    "Billbee adı": "Billbee adı",
    "Birden fazla ürün/hizmet satırını tek faturada toplayıp PDF üretin.": "Birden fazla ürün/hizmet satırını tek faturada toplayıp PDF üretin.",
    "Birim brüt": "Birim brüt",
    "Birim fiyat": "Birim fiyat",
    "Birim net": "Birim net",
    "Brüt toplam": "Brüt toplam",
    "Bu manuel Shopify faturası iptal edilecek. Devam edilsin mi?": "Bu manuel Shopify faturası iptal edilecek. Devam edilsin mi?",
    "Bitiş": "Bitiş",
    "Bize ulaşın": "Bize ulaşın",
    "Bonus işaretlenen satırlar 0 EUR tutulur ve otomatik fiyat tamiri bu kayıtları ücretlendirmez.": "Bonus işaretlenen satırlar 0 EUR tutulur ve otomatik fiyat tamiri bu kayıtları ücretlendirmez.",
    "Bonus/telafi etiketi": "Bonus/telafi etiketi",
    "Brüt": "Brüt",
    "Girilen tutar nettir; KDV seçilen orana göre üzerine eklenir.": "Girilen tutar nettir; KDV seçilen orana göre üzerine eklenir.",
    "KDV": "KDV",
    "Manuel Shopify faturası iptal edilemedi.": "Manuel Shopify faturası iptal edilemedi.",
    "Net toplam": "Net toplam",
    "Bu değerler mevcut fatura PDF ve admin manuel fatura akışlarında kullanılır.": "Bu değerler mevcut fatura PDF ve admin manuel fatura akışlarında kullanılır.",
    "Bu etiket status bakmadan admin stok havuzuna alınacak. Etiket artık kullanıcılar tarafından satın alınabilir olacak. Devam edilsin mi?": "Bu etiket status bakmadan admin stok havuzuna alınacak. Etiket artık kullanıcılar tarafından satın alınabilir olacak. Devam edilsin mi?",
    "Bu filtrelerle eşleşen müşteri bulunamadı.": "Bu filtrelerle eşleşen müşteri bulunamadı.",
    "Bu filtrede etiket yok.": "Bu filtrede etiket yok.",
    "Bu linkle kayıt olan müşteriler otomatik olarak hesabınıza bağlanır.": "Bu linkle kayıt olan müşteriler otomatik olarak hesabınıza bağlanır.",
    "Bu sayfa bakiye": "Bu sayfa bakiye",
    "Bu sayfa gönderi": "Bu sayfa gönderi",
    "Bu sayfa mağaza": "Bu sayfa mağaza",
    "Bu sipariş Packstation/Postfiliale adresli. Etiket oluşturmak için normal teslimat adresi girin.": "Bu sipariş Packstation/Postfiliale adresli. Etiket oluşturmak için normal teslimat adresi girin.",
    "Bu sipariş Packstation/Postfiliale adresli. Toplu işlemde seçilmez; tekli etiket oluşturabilirsiniz. Packstation için Postnummer bilgisi adres içinde olmalı.": "Bu sipariş Packstation/Postfiliale adresli. Toplu işlemde seçilmez; tekli etiket oluşturabilirsiniz. Packstation için Postnummer bilgisi adres içinde olmalı.",
    "Bu sipariş için gönderi yok.": "Bu sipariş için gönderi yok.",
    "Bu siparişe bağlı gönderiler": "Bu siparişe bağlı gönderiler",
    "Bugün": "Bugün",
    "Bugün Berlin saatiyle 18:00-23:59 arasında sistem kapalı olacaktır. Geçişten sonra yeni sistemimiz ve son özelliklerimizle tekrar karşınızda olacağız.": "Bugün Berlin saatiyle 18:00-23:59 arasında sistem kapalı olacaktır. Geçişten sonra yeni sistemimiz ve son özelliklerimizle tekrar karşınızda olacağız.",
    "Bugünkü gönderi ritmini ve hesabın dikkat isteyebileceği alanlarını hızlıca okuyun.": "Bugünkü gönderi ritmini ve hesabın dikkat isteyebileceği alanlarını hızlıca okuyun.",
    "Cache boyutu": "Cache boyutu",
    "Checkout'u aç": "Checkout'u aç",
    "Cloudflare D1 içinde müşteri hesabı oluşturur.": "Cloudflare D1 içinde müşteri hesabı oluşturur.",
    "Cloudflare sürüm ve audit özeti.": "Cloudflare sürüm ve audit özeti.",
    "Cloudflare taşıma sürüm ve audit durumu.": "Cloudflare taşıma sürüm ve audit durumu.",
    "Cloudflare uygulaması": "Cloudflare uygulaması",
    "CSV export": "CSV dışa aktar",
    "CSV, TSV veya XLSX dosyasındaki adresleri manuel etikete çevirin.": "CSV, TSV veya XLSX dosyasındaki adresleri manuel etikete çevirin.",
    "Carrier durum": "Carrier durum",
    "Packstation/Postfiliale adresleri bu internal DHL etiket akışında desteklenmiyor.": "Packstation/Postfiliale adresleri bu internal DHL etiket akışında desteklenmiyor.",
    "Packstation/Postfiliale adresleri bu işlemde toplu veya manuel oluşturulamaz. Lütfen sipariş satırındaki tekli etiket oluşturmayı kullanın.": "Packstation/Postfiliale adresleri bu işlemde toplu veya manuel oluşturulamaz. Lütfen sipariş satırındaki tekli etiket oluşturmayı kullanın.",
    "Packstation/Postfiliale adresleri toplu etiket işleminde seçilemez. Tekli etiket oluşturmayı kullanın.": "Packstation/Postfiliale adresleri toplu etiket işleminde seçilemez. Tekli etiket oluşturmayı kullanın.",
    "Packstation/Postfiliale adresli siparişler toplu etiket işlemine seçilemez; normal teslimat adresiyle tekli işlem yapılmalı.": "Packstation/Postfiliale adresli siparişler toplu etiket işlemine seçilemez; normal teslimat adresiyle tekli işlem yapılmalı.",
    "Packstation/Postfiliale adresli siparişler toplu etiket işlemine seçilemez; tekli etiket oluşturmayı kullanın.": "Packstation/Postfiliale adresli siparişler toplu etiket işlemine seçilemez; tekli etiket oluşturmayı kullanın.",
    "Bu gönderi zaten iptal edilmiş veya kapalı.": "Bu gönderi zaten iptal edilmiş veya kapalı.",
    "Bu gönderi iptal edilemez: DHL/taşıyıcı hareketi görünüyor. Etiket krediye iade edilmedi.": "Bu gönderi iptal edilemez: DHL/taşıyıcı hareketi görünüyor. Etiket krediye iade edilmedi.",
    "Bu gönderi iptal edilemez: taşıyıcı durumu güvenli şekilde Status offen / hareket yok olarak doğrulanamadı.": "Bu gönderi iptal edilemez: taşıyıcı durumu güvenli şekilde Status offen / hareket yok olarak doğrulanamadı.",
    "Etiket iptal edildi; kredi bakiyenize geri döndü ve sipariş tekrar etiket bekliyor.": "Etiket iptal edildi; kredi bakiyenize geri döndü ve sipariş tekrar etiket bekliyor.",
    "Etiket/gönderi iptal edilsin mi?": "Etiket/gönderi iptal edilsin mi?",
    "Etiket kredisi stoğa geri döner ve sipariş tekrar etiket bekleyen duruma alınır.": "Etiket kredisi stoğa geri döner ve sipariş tekrar etiket bekleyen duruma alınır.",
    "Gönderi iptal edilsin mi?": "Gönderi iptal edilsin mi?",
    "Gönderi iptal edildi; etiket kredisi hesabınıza geri döndü ve sipariş tekrar etiket bekliyor.": "Gönderi iptal edildi; etiket kredisi hesabınıza geri döndü ve sipariş tekrar etiket bekliyor.",
    "Gönderi kaydı bulunamadı.": "Gönderi kaydı bulunamadı.",
    "Gönderiyi iptal et": "Gönderiyi iptal et",
    "İptal başarılı olursa etiket kredisi müşteri bakiyesine geri döner ve sipariş tekrar etiket bekleyen duruma gelir.": "İptal başarılı olursa etiket kredisi müşteri bakiyesine geri döner ve sipariş tekrar etiket bekleyen duruma gelir.",
    "Sadece DHL hareketi olmayan / Status offen etiketler iptal edilebilir.": "Sadece DHL hareketi olmayan / Status offen etiketler iptal edilebilir.",
    "Seçili gönderiler iptal edilsin mi?": "Seçili gönderiler iptal edilsin mi?",
    "Teknik hata kayıtları müşteri iptaliyle krediye alınamaz.": "Teknik hata kayıtları müşteri iptaliyle krediye alınamaz.",
    "Çıkış": "Çıkış",
    "D1 snapshot": "D1 anlık görüntüsü",
    "Değer": "Değer",
    "Değişim": "Değişim",
    "Destek": "Destek",
    "Detay": "Detay",
    "Destek merkezi": "Destek merkezi",
    "Destek raporu yükleniyor": "Destek raporu yükleniyor",
    "Destek talebi": "Destek talebi",
    "Destek talebi yok.": "Destek talebi yok.",
    "Destek talepleri admin rapor ekranına referans numarasıyla düşer.": "Destek talepleri admin rapor ekranına referans numarasıyla düşer.",
    "Desteklenen pazar yerleri": "Desteklenen pazar yerleri",
    "Devre dışı": "Devre dışı",
    "DHL hata": "DHL bile",
    "DHL hata oranı": "DHL hata oranı",
    "DHL kontrol": "DHL kontrolü",
    "DHL kontrol özeti": "DHL kontrol özeti",
    "DHL kontrol performansı": "DHL kontrol performansı",
    "DHL taşıyıcı kontrol sonuçları ve hatalı/şüpheli etiket sinyalleri.": "DHL taşıyıcı kontrol sonuçları ve hatalı/şüpheli etiket sinyalleri.",
    "DHL event timeline": "DHL event timeline",
    "DHL takip sayfasını yeni sekmede aç": "DHL takip sayfasını yeni sekmede aç",
    "DHL/taşıyıcı kontrol kuyrukları ve sonuç özetleri.": "DHL/taşıyıcı kontrol kuyrukları ve sonuç özetleri.",
    "Dış servis ihtiyacı": "Dış servis ihtiyacı",
    "Dış kullanım": "Dış kullanım",
    "Dışa aktarım": "Dışa aktarım",
    "Diğer": "Diğer",
    "Durum": "Durum",
    "Doğrulama bekleyen": "Doğrulama bekleyen",
    "Doğrulanmış": "Doğrulanmış",
    "dosya işlendi": "dosya işlendi",
    "Dosya seç": "Dosya seç",
    "Durumu yenile": "Durumu yenile",
    "Düzenle": "Düzenle",
    "E-Mail prüfen": "E-postayı kontrol edin",
    "E-posta 2FA": "E-posta 2FA",
    "E-posta adresi": "E-posta adresi",
    "E-posta doğrulama": "E-posta doğrulama",
    "E-posta ile ikinci doğrulama.": "E-posta ile ikinci doğrulama.",
    "eBay bağla": "eBay bağla",
    "eBay bağlantıları": "eBay bağlantıları",
    "eBay bağlantısı yok.": "eBay bağlantısı yok.",
    "eBay hesabınızı güvenli bağlantı akışıyla ekleyin.": "eBay hesabınızı güvenli bağlantı akışıyla ekleyin.",
    "eBay mağazası bağla": "eBay mağazası bağla",
    "eBay OAuth": "eBay OAuth",
    "eBay OAuth başlat": "eBay OAuth başlat",
    "eBay ortamı": "eBay ortamı",
    "eBay yeniden bağla": "eBay yeniden bağla",
    "Eğitim videoları": "Eğitim videoları",
    "Eğitimler": "Eğitimler",
    "Eğitimler yükleniyor": "Eğitimler yükleniyor",
    "Ekibiniz için sınırlı müşteri hesabı oluşturun.": "Ekibiniz için sınırlı müşteri hesabı oluşturun.",
    "Ekip üyeleri": "Ekip üyeleri",
    "Ekip üyeleri yükleniyor": "Ekip üyeleri yükleniyor",
    "Ekip üyesi yok.": "Ekip üyesi yok.",
    "Ekip yönetimi": "Ekip yönetimi",
    "Eksik/hatalı etiketler": "Eksik/hatalı etiketler",
    "empfänger": "alıcı",
    "Eski sistemdeki temel store ayarları ve platform credential bilgileri.": "Eski sistemdeki temel store ayarları ve platform credential bilgileri.",
    "Eski veya yanlış faturaların toplu otomatik düzeltilmesi ayrıca ele alınacak.": "Eski veya yanlış faturaların toplu otomatik düzeltilmesi ayrıca ele alınacak.",
    "Etiket / indirme": "Etiket / indirme",
    "Etiket bakiyeleri": "Etiket bakiyeleri",
    "Etiket bakiyesi": "Etiket bakiyesi",
    "Etiket bakiyesi ve faturalar": "Etiket bakiyesi ve faturalar",
    "Etiket bakiyesi yok.": "Etiket bakiyesi yok.",
    "Etiket bilgileri yükleniyor": "Etiket bilgileri yükleniyor",
    "Etiket çıktısı": "Etiket çıktısı",
    "Etiket durumu": "Etiket durumu",
    "Etiket Envanteri": "Etiket Envanteri",
    "Etiket envanteri": "Etiket envanteri",
    "Etiket envanteri ve faturalama": "Etiket envanteri ve faturalama",
    "Hatalı Etiketler": "Hatalı Etiketler",
    "Hatalı etiket detayı": "Hatalı etiket detayı",
    "Hatalı etiket yok.": "Hatalı etiket yok.",
    "Hatalı etiketler alınamadı.": "Hatalı etiketler alınamadı.",
    "Hatalı etiketler yükleniyor": "Hatalı etiketler yükleniyor",
    "Müşteri İptalleri": "Müşteri İptalleri",
    "Taşıyıcı Kontrol Hataları": "Taşıyıcı Kontrol Hataları",
    "Etiket kaynağı yükle": "Etiket kaynağı yükle",
    "Etiket Kontrolleri": "Etiket Kontrolleri",
    "Etiket kontrolleri": "Etiket kontrolleri",
    "Etiket kredi sepeti": "Etiket kredi sepeti",
    "Etiket kredilerini checkout ile satın alın ve ödeme sonrası bakiyeye işleyin.": "Etiket kredilerini checkout ile satın alın ve ödeme sonrası bakiyeye işleyin.",
    "Etiket oluştur": "Etiket oluştur",
    "Etiket oluşturma": "Etiket oluşturma",
    "Etiket oluştu": "Etiket oluştu",
    "Etiket paketleri": "Etiket paketleri",
    "Etiket sağlayıcı": "Etiket sağlayıcı",
    "Etiket satın al": "Etiket satın al",
    "Etiket Satın Al": "Etiket Satın Al",
    "Etiket satın alma": "Etiket satın alma",
    "Etiket satın alma faturaları": "Etiket satın alma faturaları",
    "Etiket satın almaları": "Etiket satın almaları",
    "Etiket Ürünleri": "Etiket Ürünleri",
    "Etiket ürünleri için müşteri bazlı fiyat tanımları.": "Etiket ürünleri için müşteri bazlı fiyat tanımları.",
    "Etiket ürünleri yükleniyor": "Etiket ürünleri yükleniyor",
    "Etiket ürünleri, stok hareketleri ve taşıyıcı kontrolleri.": "Etiket ürünleri, stok hareketleri ve taşıyıcı kontrolleri.",
    "Etiket ürünü": "Etiket ürünü",
    "Etiket ürünü yok": "Etiket ürünü yok",
    "Etiket ürünü yükleniyor": "Etiket ürünü yükleniyor",
    "Etiket verileri yükleniyor": "Etiket verileri yükleniyor",
    "Etikete dönüştürülmeye hazır": "Etikete dönüştürülmeye hazır",
    "Etiketi oluştur": "Etiketi oluştur",
    "Etiketler": "Etiketler",
    "Etiketlere dön": "Etiketlere dön",
    "Etikette SKU": "SKU'yu etiketleyin",
    "Etiket kullanıma açılamadı.": "Etiket kullanıma açılamadı.",
    "etiketürünü": "etiketürünü",
    "export dosyasına yazıldı": "export dosyasına yazıldı",
    "Fatura / ödeme": "Fatura / ödeme",
    "Fatura adresi": "Fatura adresi",
    "Fatura adresi farklı": "Fatura adresi farklı",
    "Fatura adresi yedeği": "Fatura adresi yedeği",
    "Fatura ayarları": "Fatura ayarları",
    "Fatura bilgileri": "Fatura bilgileri",
    "Fatura durumu": "Fatura durumu",
    "Fatura posta kodu": "Fatura posta kodu",
    "Fatura satırı yok.": "Fatura satırı yok.",
    "Fatura şehir": "Fatura şehir",
    "Fatura toplamı": "Fatura toplamı",
    "Fatura ülke": "Fatura ülke",
    "Fatura ve etiket satın alma kayıtları.": "Fatura ve etiket satın alma kayıtları.",
    "Fatura ve gönderici adresi": "Fatura ve gönderici adresi",
    "Fatura ve gönderici bilgileri": "Fatura ve gönderici bilgileri",
    "Fatura yok.": "Fatura yok.",
    "Faturalama": "Faturalama",
    "Faturalama verisi yükleniyor": "Faturalama verisi yükleniyor",
    "Faturalar": "Faturalar",
    "Faturalar, PDF üretimi ve etiket satın alma faturaları.": "Faturalar, PDF üretimi ve etiket satın alma faturaları.",
    "Faturalara dön": "Faturalara dön",
    "Final eşitleme": "Final eşitleme",
    "Final senkron": "Final senkron",
    "Fiyat matrisi": "Fiyat matrisi",
    "Fiyatları aç": "Fiyatları aç",
    "Gadget kapatma": "Gadget kapatma",
    "Gadget tarafındaki server link senaryosuyla aynı başlat/onayla akışını kullanır.": "Gadget tarafındaki server link senaryosuyla aynı başlat/onayla akışını kullanır.",
    "Geçiş planı": "Geçiş planı",
    "Genel Bakış": "Genel Bakış",
    "Genel not": "Genel değil",
    "Gizli anahtar": "Gizli anahtar",
    "Gönder": "Gönder",
    "Gönderen adı": "Gönderen adı",
    "Gönderi": "Gönderi",
    "Gönderi başarı oranı": "Gönderi başarı oranı",
    "Gönderi bilgileri": "Gönderi bilgileri",
    "Gönderi bilgisi": "Gönderi bilgisi",
    "Gönderi bulunamadı": "Gönderi bulunamadı",
    "Gönderi detayı açılamadı": "Gönderi detayı açılamadı",
    "Gönderi detayı yükleniyor": "Gönderi detayı yükleniyor",
    "Gönderi tipi": "Gönderi tipi",
    "Gönderi yok.": "Gönderi yok.",
    "Gönderici adı": "Gönderici adı",
    "Gönderici adresi": "Gönderici adresi",
    "Gönderici posta kodu": "Gönderici posta kodu",
    "Gönderici şehir": "Gönderici şehir",
    "Gönderici ülke": "Gönderici ülke",
    "Gönderiler": "Gönderiler",
    "Gönderiler yükleniyor": "Gönderiler yükleniyor",
    "Gönderilere dön": "Gönderilere dön",
    "Gönderim": "Gönderim",
    "gönderitipi": "gönderitipi",
    "Görünen DHL etiketlerini kontrol et": "Görünen DHL etiketlerini kontrol et",
    "Gün": "Gün",
    "Güncelleme": "Güncelleme",
    "Günlük destek raporu yok.": "Günlük destek raporu yok.",
    "Günlük teknik talep raporu": "Günlük teknik talep raporu",
    "Güvenlik": "Güvenlik",
    "Hareketli / kullanılmış": "Hareketli / kullanılmış",
    "Harici sipariş": "Harici sipariş",
    "Hata kayıtları": "Hata kayıtları",
    "Hata kayıtları ve arka plan işlem izleri.": "Hata kayıtları ve arka plan işlem izleri.",
    "Hatalı": "Hatalı",
    "Hazır": "Hazır",
    "Hazır etiketler": "Hazır etiketler",
    "Hazır stok:": "Hazır stok:",
    "Hazırlık durumu": "Hazırlık durumu",
    "Henüz affiliate profiliniz yok.": "Henüz affiliate profiliniz yok.",
    "Henüz ekip üyesi yok.": "Henüz ekip üyesi yok.",
    "Henüz hazır değil": "Henüz hazır değil",
    "Henüz mağaza yok.": "Henüz mağaza yok.",
    "Henüz referans kaydı yok.": "Henüz referans kaydı yok.",
    "Henüz sipariş yok.": "Henüz sipariş yok.",
    "Her şey yolunda": "Her şey yolunda",
    "Hesaba geç": "Hesaba geç",
    "Hesap": "Hesap",
    "Hesap aktif": "Hesap aktif",
    "Hesap aktif.": "Hesap aktif.",
    "Hesap bilgileri": "Hesap bilgileri",
    "Hesap güvenliği": "Hesap güvenliği",
    "Hesap hazır": "Hesap hazır",
    "Hesap hazırlığı": "Hesap hazırlığı",
    "Hesap şifrenizi güvenli şekilde güncelleyin.": "Hesap şifrenizi güvenli şekilde güncelleyin.",
    "Hızlı yönetim": "Hızlı yönetim",
    "Hareket yok": "Hareket yok",
    "Importu oluştur": "Importu oluştur",
    "İade": "İade",
    "İade sinyali": "İade sinyali",
    "İç platformlar": "İç platformlar",
    "İç servis": "İç servis",
    "İptal": "İptal",
    "İptal edilen etiketler": "İptal edilen etiketler",
    "İptal kayıtları": "İptal kayıtları",
    "İstemci anahtarı": "İstemci anahtarı",
    "İstemci gizli anahtarı": "İstemci gizli anahtarı",
    "İstemci ID": "İstemci ID",
    "İstenen": "İstenen",
    "İşlem": "İşlem",
    "JTL DB adı": "JTL DB adı",
    "JTL DB kullanıcı": "JTL DB kullanıcı",
    "JTL DB port": "JTL DB bağlantı noktası",
    "JTL DB sunucu": "JTL DB sunucu",
    "JTL DB şifre": "JTL DB şifre",
    "JTL siparişinde ağırlık bilgisi gelmedi. Yanlış ürün seçilmemesi için etiket ürününü manuel seçin.": "JTL siparişinde ağırlık bilgisi gelmedi. Yanlış ürün seçilmemesi için etiket ürününü manuel seçin.",
    "JTL URL": "JTL URL'si",
    "Katıldığınızda size özel referans kodu ve kayıt linki oluşur.": "Katıldığınızda size özel referans kodu ve kayıt linki oluşur.",
    "Kaydet ve PDF üret": "Kaydet ve PDF üret",
    "Kaydedilmiş DHL event yok.": "Kaydedilmiş DHL event yok.",
    "Kayıt": "Kayıt",
    "Kayıt bulunamadı.": "Kayıt bulunamadı.",
    "Kayıt linki": "Kayıt linki",
    "Kapat": "Kapat",
    "Kayıt yok.": "Kayıt yok.",
    "Kayıtlı": "Kayıtlı",
    "Kaynak platform senkronu": "Kaynak platform senkronu",
    "Kaynak platforma takip gönder": "Kaynak platforma takip gönder",
    "Kaynak senkron": "Kaynak senkron",
    "Kargo adresi": "Kargo adresi",
    "Kargo adresinden farklı": "Kargo adresinden farklı",
    "Kalan": "Kalan",
    "KDV %19": "KDV %19",
    "KDV, numara formatı ve kredi faturası kuralları.": "KDV, numara formatı ve kredi faturası kuralları.",
    "Kenpost ana sayfa": "Kenpost ana sayfa",
    "Kenpost fatura numaraları, KDV oranı ve kredi faturası kuralları.": "Kenpost fatura numaraları, KDV oranı ve kredi faturası kuralları.",
    "Kenpost operasyon verisi": "Kenpost operasyon verisi",
    "Kenpost yeni panel": "Kenpost yeni panel",
    "Kimlik bilgisi": "Kimlik bilgisi",
    "Komisyon hareketi yok.": "Komisyon hareketi yok.",
    "Komisyon hareketleri": "Komisyon hareketleri",
    "Komisyon ve bonus": "Komisyon ve bonus",
    "Kontrol çalışmaları": "Kontrol çalışmaları",
    "Kontrol edilen": "Kontrol edilen",
    "Kontrol paneli": "Kontrol paneli",
    "Kontrol paneli açılamadı": "Kontrol paneli açılamadı",
    "Konu ve mesajı yazın; ekip bu referansla takip eder.": "Konu ve mesajı yazın; ekip bu referansla takip eder.",
    "Kredi Durumu": "Kredi Durumu",
    "Kredi faturası": "Kredi faturası",
    "Kredileri işle ve faturala": "Kredileri işle ve faturala",
    "Kullanıcı": "Kullanıcı",
    "Kullanıcı adı": "Kullanıcı adı",
    "Kullanıcı eğitim ve Almanca etiket indirme içerikleri.": "Kullanıcı eğitim ve Almanca etiket indirme içerikleri.",
    "Kullanıcı video eğitimleri ve Almanca etiket indirme anlatımları.": "Kullanıcı video eğitimleri ve Almanca etiket indirme anlatımları.",
    "Kullanılabilir etiket": "Kullanılabilir etiket",
    "Kullanılabilir etiketler": "Kullanılabilir etiketler",
    "Kullanılan kod": "Kullanılan kod",
    "kullanıma açıldı.": "kullanıma açıldı.",
    "Kullanım": "Kullanım",
    "Label hatası": "Label hatası",
    "Linki kopyala": "Linki kopyala",
    "Mağaza": "Mağaza",
    "Mağaza adı": "Mağaza adı",
    "Mağaza aktif": "Mağaza aktif",
    "Mağaza ayarları": "Mağaza ayarları",
    "Mağaza bağlantıları": "Mağaza bağlantıları",
    "Mağaza bağlantısı": "Mağaza bağlantısı",
    "Mağaza hareketlerini, etiket hazır durumunu ve gönderi temposunu tek yerden takip edin.": "Mağaza hareketlerini, etiket hazır durumunu ve gönderi temposunu tek yerden takip edin.",
    "Mağaza oluştur": "Mağaza oluştur",
    "Mağaza URL": "Mağaza URL",
    "Mağaza yükleniyor": "Mağaza yükleniyor",
    "Mağazalar": "Mağazalar",
    "Mağazalar yükleniyor": "Mağazalar yükleniyor",
    "Henüz aktif mağaza yok.": "Henüz aktif mağaza yok.",
    "Pasif mağazalar": "Pasif mağazalar",
    "Pasif mağazalar ana listeden ayrılır; geçmiş ve yeniden aktifleştirme erişimi korunur.": "Pasif mağazalar ana listeden ayrılır; geçmiş ve yeniden aktifleştirme erişimi korunur.",
    "Pasif mağazaları gizle": "Pasif mağazaları gizle",
    "Pasif mağazaları göster": "Pasif mağazaları göster",
    "Mağazalara dön": "Mağazalara dön",
    "Mağazalara git": "Mağazalara git",
    "Mağazalarım": "Mağazalarım",
    "mağazasında fulfillment/tracking kaydını yeniden dener.": "mağazasında fulfillment/tracking kaydını yeniden dener.",
    "MAK{yıl}-{satın alma id}": "MAK{yıl}-{satın alma id}",
    "Manuel fatura oluştur": "Manuel fatura oluştur",
    "Max gram": "Maksimum gram",
    "Max Mustermann Musterstr. 12 10115 Berlin": "Max Mustermann Musterstr. 12 10115 Berlin",
    "Menüyü aç": "Menüyü aç",
    "Menüyü kapat": "Menüyü kapat",
    "Mevcut snapshot import edildi": "Mevcut snapshot import edildi",
    "Mevcut şifre": "Mevcut şifre",
    "Min gram": "benim gramım",
    "Müşteri": "Müşteri",
    "Müşteriye bağlı": "Müşteriye bağlı",
    "Müşteri bulunamadı": "Müşteri bulunamadı",
    "Müşteri detayı açılamadı": "Müşteri detayı açılamadı",
    "Müşteri detayı yükleniyor": "Müşteri detayı yükleniyor",
    "Müşteri etiket bakiyeleri.": "Müşteri etiket bakiyeleri.",
    "Müşteri fiyatları": "Müşteri fiyatları",
    "Müşteri hesabını oluşturmak için temel bilgileri girin.": "Müşteri hesabını oluşturmak için temel bilgileri girin.",
    "Müşteri hesapları hazırlanıyor": "Müşteri hesapları hazırlanıyor",
    "Müşteri hesaplarını, mağaza bağlantılarını, etiket bakiyelerini ve destek geçişlerini tek ekrandan yönetin.": "Müşteri hesaplarını, mağaza bağlantılarını, etiket bakiyelerini ve destek geçişlerini tek ekrandan yönetin.",
    "Müşteri Kontrol Merkezi": "Müşteri Kontrol Merkezi",
    "Müşteri olarak gör": "Müşteri olarak gör",
    "Müşteri oluştur": "Müşteri oluştur",
    "Müşteri paneli": "Müşteri paneli",
    "Müşteri plan kayıtları ve abonelik segmentleri.": "Müşteri plan kayıtları ve abonelik segmentleri.",
    "Müşteri seç": "Müşteri seç",
    "Müşteri teknik destek talepleri, günlük rapor ve öncelikli kayıtlar.": "Müşteri teknik destek talepleri, günlük rapor ve öncelikli kayıtlar.",
    "Müşteri teknik talepleri ve günlük rapor.": "Müşteri teknik talepleri ve günlük rapor.",
    "Müşteri ve alt müşteri yönetimi": "Müşteri ve alt müşteri yönetimi",
    "Müşteri ve sistem hata referansları.": "Müşteri ve sistem hata referansları.",
    "Müşteri, şirket veya e-posta ara": "Müşteri, şirket veya e-posta ara",
    "Müşteriler": "Müşteriler",
    "Müşterilere dön": "Müşterilere dön",
    "Müşteriye atanabilecek yeni plan tanımı oluşturun.": "Müşteriye atanabilecek yeni plan tanımı oluşturun.",
    "myshopify.com domaini": "myshopify.com alan adları",
    "Object key:": "Nesne anahtarı:",
    "olarak müşteri panelindesiniz.": "olarak müşteri panelindesiniz.",
    "Oluştur": "Oluştur",
    "Oluşturulan gönderi ve etiket kayıtları; arama, sayfalama ve arka plan takip senkronu ile hızlı yönetim.": "Oluşturulan gönderi ve etiket kayıtları; arama, sayfalama ve arka plan takip senkronu ile hızlı yönetim.",
    "Oluşturuldu": "Oluşturuldu",
    "Oluşturulma": "Oluşturulma",
    "Onboarding açılamadı": "Onboarding açılamadı",
    "Online seller prefix": "Çevrimiçi satıcı öneki",
    "Operasyon Nabzı": "Operasyon Nabzı",
    "Operasyon notu": "Operasyon notu",
    "Açık olduğunda sistem bu mağazadan siparişleri arka planda düzenli çeker.": "Açık olduğunda sistem bu mağazadan siparişleri arka planda düzenli çeker.",
    "Arama": "Arama",
    "Atlandı": "Atlandı",
    "Çalışıyor": "Çalışıyor",
    "Filtrele": "Filtrele",
    "Günde bir": "Günde bir",
    "Hata sayısı": "Hata sayısı",
    "Hatalar": "Hatalar",
    "Kontrol raporu": "Kontrol raporu",
    "Kontrol geçmişi": "Kontrol geçmişi",
    "Kontrol mesajı": "Kontrol mesajı",
    "Kontrol raporu alınamadı.": "Kontrol raporu alınamadı.",
    "Kontrol raporu yükleniyor": "Kontrol raporu yükleniyor",
    "Kontrol sıklığı": "Kontrol sıklığı",
    "Listelenen": "Listelenen",
    "Mağaza kontrol raporu": "Mağaza kontrol raporu",
    "Mağaza otomatik kontrol durumu": "Mağaza otomatik kontrol durumu",
    "Mağaza, müşteri veya e-posta": "Mağaza, müşteri veya e-posta",
    "Otomatik kontrol": "Otomatik kontrol",
    "Otomatik sipariş alma": "Otomatik sipariş alma",
    "Otomatik sipariş alma denemeleri, hatalar ve sıradaki kontroller.": "Otomatik sipariş alma denemeleri, hatalar ve sıradaki kontroller.",
    "Otomatik sipariş alma hataları ve sıradaki kontroller.": "Otomatik sipariş alma hataları ve sıradaki kontroller.",
    "Otomatik sipariş kontrolü": "Otomatik sipariş kontrolü",
    "Sıradaki kontrol": "Sıradaki kontrol",
    "Son başarılı": "Son başarılı",
    "Son kontrol denemeleri": "Son kontrol denemeleri",
    "Son deneme": "Son deneme",
    "Son hata": "Son hata",
    "Son carrier event": "Son carrier event",
    "Son güncelleme": "Son güncelleme",
    "Şimdi kontrol et": "Şimdi kontrol et",
    "5 dakikada bir": "5 dakikada bir",
    "10 dakikada bir": "10 dakikada bir",
    "15 dakikada bir": "15 dakikada bir",
    "30 dakikada bir": "30 dakikada bir",
    "Saatte bir": "Saatte bir",
    "3 saatte bir": "3 saatte bir",
    "6 saatte bir": "6 saatte bir",
    "12 saatte bir": "12 saatte bir",
    "Operasyon, hata ve entegrasyon ayarları.": "Operasyon, hata ve entegrasyon ayarları.",
    "Opsiyonel URL": "Opsiyonel URL",
    "Ortam durumu": "Ortam durumu",
    "OTTO adı": "OTTO adı",
    "Ödeme entegrasyonu eksik:": "Ödeme entegrasyonu eksik:",
    "Ödemeyi doğrula": "Ödemeyi doğrula",
    "Ödendi": "Ödendi",
    "Ödenen": "Ödenen",
    "Önbellek sipariş": "Önbellek sipariş",
    "Önceki": "Önceki",
    "Öncelik": "Öncelik",
    "Öncelikli": "Öncelikli",
    "Paket adedi": "Paket adedi",
    "Panel bilgileri yüklenmeye hazır": "Panel bilgileri yüklenmeye hazır",
    "parça": "parça",
    "PayPal, Klarna, banka havalesi, SEPA ve eğitim dokümanları ödeme sağlayıcı kararından sonra bağlanacak.": "PayPal, Klarna, banka havalesi, SEPA ve eğitim dokümanları ödeme sağlayıcı kararından sonra bağlanacak.",
    "Pazar yeri bağlantılarınızı, sipariş senkronunu ve mağaza ayarlarını tek yerden yönetin.": "Pazar yeri bağlantılarınızı, sipariş senkronunu ve mağaza ayarlarını tek yerden yönetin.",
    "Pazar yeri takip yazımı, label üretimi ve iade/iptal sinyalleri.": "Pazar yeri takip yazımı, label üretimi ve iade/iptal sinyalleri.",
    "Pazar yerine takip yazımı başarılı olan gönderiler baz alınır.": "Pazar yerine takip yazımı başarılı olan gönderiler baz alınır.",
    "PDF aç": "PDF aç",
    "PDF olan": "PDF olan",
    "PDF ZIP": "PDF ZIP",
    "PDF boyutu": "PDF boyutu",
    "PDF etiket kaynaklarını D1/R2 akışına aktarır.": "PDF etiket kaynaklarını D1/R2 akışına aktarır.",
    "PDF tarihi": "PDF geçmişi",
    "PDF yükleme": "PDF yükleme",
    "Performans risk göstergeleri": "Performans risk göstergeleri",
    "Plan adı": "Plan adı",
    "Plan listesi": "Plan listesi",
    "Plan ve etiket satın alma durumu.": "Plan ve etiket satın alma durumu.",
    "Platform bağlantı bilgilerinizi güvenli şekilde ekleyin.": "Platform bağlantı bilgilerinizi güvenli şekilde ekleyin.",
    "Platform bağlantı ve senkron özeti.": "Platform bağlantı ve senkron özeti.",
    "Platform bağlantıları ve raporlar": "Platform bağlantıları ve raporlar",
    "Platformlar": "Platformlar",
    "Platformlardan alınan son siparişler.": "Platformlardan alınan son siparişler.",
    "Posta kodu": "Posta kodu",
    "Posta kodu kontrol edilemedi.": "Posta kodu kontrol edilemedi.",
    "Profil": "Profil",
    "Profil yükleniyor": "Profil yükleniyor",
    "Profili kaydet": "Profili kaydet",
    "Programa katıl": "Programa katıl",
    "Prüfen Sie Ihren Posteingang für den Verifizierungslink.": "Doğrulama bağlantısı için gelen kutunuzu kontrol edin.",
    "R2 dosya": "R2 dosya",
    "Raporlar": "Raporlar",
    "RE-{yıl}-{sıra}": "RE-{yıl}-{sıra}",
    "Referans": "Referans",
    "Referans bağlantıları": "Referans bağlantıları",
    "Referans ve kazanç": "Referans ve kazanç",
    "Referans kodları, yönlendirilen müşteriler ve kullanım komisyonları.": "Referans kodları, yönlendirilen müşteriler ve kullanım komisyonları.",
    "Referans kodu": "Referans kodu",
    "Referans linki oluşturup yönlendirdiğiniz müşterilerin kullanım komisyonlarını takip edin.": "Referans linki oluşturup yönlendirdiğiniz müşterilerin kullanım komisyonlarını takip edin.",
    "Referans linkiniz": "Referans linkiniz",
    "Retoure / iade": "İade / iade",
    "Rol kapsamı": "Rol kapsamı",
    "Rol sistemi aktif": "Rol sistemi aktif",
    "S3 ortamı": "S3 ortamı",
    "Satıcı": "Satıcı",
    "Satın al": "Satın al",
    "Satın alınabilir ürün yok.": "Satın alınabilir ürün yok.",
    "Satın alma": "Satın alma",
    "Satın alma toplamı": "Satın alma toplamı",
    "Satın alma yok.": "Satın alma yok.",
    "satır": "satır",
    "Satır değişiklikleri kaydedildiğinde PDF yeniden üretilir ve bağlı komisyon tutarları güncellenir.": "Satır değişiklikleri kaydedildiğinde PDF yeniden üretilir ve bağlı komisyon tutarları güncellenir.",
    "Satır ekle": "Satır ekle",
    "Satır notu": "Satır notu",
    "Satırı sil": "Satırı sil",
    "Satırlar": "Onlar satıyorlar",
    "Seçilen müşteri için ürün bazlı özel fiyatları düzenleyin.": "Seçilen müşteri için ürün bazlı özel fiyatları düzenleyin.",
    "Senkron durumu": "Senkron durumu",
    "Senkron sipariş": "Senkron sipariş",
    "Sepete satır ekle": "Sepete satır ekle",
    "Shopify checkout bağlantılı": "Shopify checkout bağlantılı",
    "Shopify gönderim durumu": "Shopify gönderim durumu",
    "Shopify mesajı": "Shopify mesajı",
    "Shopify ödeme öncesi KDV davranışı Shopify checkout tarafıyla birlikte incelenecek.": "Shopify ödeme öncesi KDV davranışı Shopify checkout tarafıyla birlikte incelenecek.",
    "Shipment ID": "Shipment ID",
    "Sıfırla": "Sıfırla",
    "Sınırlı müşteri görünümü": "Sınırlı müşteri görünümü",
    "sipariş": "sipariş",
    "Sipariş": "Sipariş",
    "Sipariş bilgisi": "Sipariş bilgisi",
    "Sipariş bulunamadı": "Sipariş bulunamadı",
    "Sipariş detayı açılamadı": "Sipariş detayı açılamadı",
    "Sipariş detayı yükleniyor": "Sipariş detayı yükleniyor",
    "Sipariş faturası": "Sipariş faturası",
    "Sipariş listesi": "Sipariş listesi",
    "Sipariş no": "Sipariş no",
    "Sipariş sayısı": "Sipariş sayısı",
    "Sipariş seçerek veya manuel adres girerek etiket üretin.": "Sipariş seçerek veya manuel adres girerek etiket üretin.",
    "Sipariş seçin": "Sipariş seçin",
    "Sipariş senkron servisi Cloudflare içine alınmış durumda.": "Sipariş senkron servisi Cloudflare içine alınmış durumda.",
    "Sipariş senkronu ve platform servis durumu.": "Sipariş senkronu ve platform servis durumu.",
    "Sipariş ve gönderi operasyonları": "Sipariş ve gönderi operasyonları",
    "Sipariş ve gönderi yönetimi": "Sipariş ve gönderi yönetimi",
    "Sipariş verisi": "Sipariş verisi",
    "Sipariş yok.": "Sipariş yok.",
    "Siparişler": "Siparişler",
    "Siparişler yükleniyor": "Siparişler yükleniyor",
    "Siparişlere dön": "Siparişlere dön",
    "Siparişleri al": "Siparişleri al",
    "Siparişleri görüntüle": "Siparişleri görüntüle",
    "siparişno": "siparişno",
    "Siparişten veya manuel adresten gönderi oluşturun.": "Siparişten veya manuel adresten gönderi oluşturun.",
    "Sistemde kayıtlı çıktı": "Sistemde kayıtlı çıktı",
    "Sistemdeki sipariş kayıtları.": "Sistemdeki sipariş kayıtları.",
    "Site adı": "Site adı",
    "Son 24 saat": "Son 24 saat",
    "Son 7 gün": "Son 7 gün",
    "Son denetim": "Son denetim",
    "Son destek talepleri": "Son destek talepleri",
    "Son giriş": "Son giriş",
    "Son giriş:": "Son giriş:",
    "Son gönderiler": "Son gönderiler",
    "Son hareket": "Son hareket",
    "Son hareketler": "Son hareketler",
    "Son hata kayıtları": "Son hata kayıtları",
    "Son kayıt": "Son kayıt",
    "Son kayıtlar": "Son kayıtlar",
    "Son kaynak etiketleri": "Son kaynak etiketleri",
    "Son senkron": "Son senkron",
    "Son siparişler": "Son siparişler",
    "Sonra bakılacak notlar": "Sonra bakılacak notlar",
    "Standart KDV": "Standart KDV",
    "straße": "sokak",
    "Süresi biten": "Süresi biten",
    "Süresi biten etiketler için": "Süresi biten etiketler için",
    "Süresi bitmiş etiketler": "Süresi bitmiş etiketler",
    "Sürüm": "Sürüm",
    "Sürüm geçmişi, dağıtım versiyonu ve son ürün değişiklikleri.": "Sürüm geçmişi, dağıtım versiyonu ve son ürün değişiklikleri.",
    "Sürüm Notları": "Sürüm Notları",
    "Mevcut Ürün Sürümü": "Mevcut Ürün Sürümü",
    "Zaman Çizelgesi Kayıtları": "Zaman Çizelgesi Kayıtları",
    "Son Sürüm": "Son Sürüm",
    "Mevcut sürüm geçmişi aynı eski yapıdan okunur; yeni kayıtlar son sürümden devam eder.": "Mevcut sürüm geçmişi aynı eski yapıdan okunur; yeni kayıtlar son sürümden devam eder.",
    "şehir": "şehir",
    "Şehir": "Şehir",
    "Şehir kontrol ediliyor": "Şehir kontrol ediliyor",
    "Şifre": "Şifre",
    "Şifre tekrar": "Şifre tekrar",
    "Şifreli alanlar boş bırakılırsa mevcut kayıt korunur.": "Şifreli alanlar boş bırakılırsa mevcut kayıt korunur.",
    "Şifreyi güncelle": "Şifreyi güncelle",
    "Şu anda kullanıma hazır": "Şu anda kullanıma hazır",
    "Stok kaynak etiketi void durumunda.": "Stok kaynak etiketi void durumunda.",
    "Stok kaynaklarında status=void olan etiketler. Status offen grubu teslim edildi veya yolda sinyali olmayan açık DHL bildirimlerini ayrı gösterir.": "Stok kaynaklarında status=void olan etiketler. Status offen grubu teslim edildi veya yolda sinyali olmayan açık DHL bildirimlerini ayrı gösterir.",
    "Status offen": "Status offen",
    "Takip API": "Takip API",
    "Takip": "Takip",
    "Takip API açılamadı": "Takip API açılamadı",
    "Takip API durumu yükleniyor": "Takip API durumu yükleniyor",
    "Takip başarılı": "Takip başarılı",
    "Takip bekleyen": "Takip bekleyen",
    "Takip geri yazma": "Takip geri yazma",
    "Takip hatalı": "Takip hatalı",
    "Takip hatası": "Takip hatası",
    "Takip mesajı": "Takip mesajı",
    "Takip no": "Takip no",
    "Takip no, sipariş no veya alıcı ara": "Takip no, sipariş no veya alıcı ara",
    "Takip performansı": "Takip performansı",
    "Takip senkronu": "Takip senkronu",
    "Takip ve gönderi performansı": "Takip ve gönderi performansı",
    "Takip zamanı": "Takip zamanı",
    "Taşıma sonrası müşteri hesabı hazırlık adımları.": "Taşıma sonrası müşteri hesabı hazırlık adımları.",
    "Taşıyıcı": "Taşıyıcı",
    "Taşıyıcı kontrolü": "Taşıyıcı kontrolü",
    "Taşıyıcı kontrolünde sorunlu işaretlenen etiketler.": "Taşıyıcı kontrolünde sorunlu işaretlenen etiketler.",
    "Tek adres kutusu": "Tek adres kutusu",
    "Teknik sorun": "Teknik sorun",
    "Teknik detay": "Teknik detay",
    "Tekrar hoş geldin": "Tekrar hoş geldin",
    "Teslim edildi": "Teslim edildi",
    "Temiz / açık": "Temiz / açık",
    "Telafi": "Telafi",
    "Telafi mesajı": "Telafi mesajı",
    "Teslim sinyali": "Teslim sinyali",
    "Toplam adet": "Toplam adet",
    "Toplam void": "Toplam void",
    "Toplam hesap": "Toplam hesap",
    "Toplam: EUR": "Üst kuzu: EUR",
    "Toplu manuel import": "Toplu manuel import",
    "Tracking sync": "İzleme senkronizasyonu",
    "Tüketici anahtarı": "Tüketici anahtarı",
    "Tüketici gizli anahtarı": "Tüketici gizli anahtarı",
    "Tüketilen": "Tüketilen",
    "Tüm durumlar": "Tüm durumlar",
    "Tüm takip senkronları": "Tüm takip senkronları",
    "Tümü": "Tümü",
    "Uygulama içinde oluşan müşteri ve admin hata referansları.": "Uygulama içinde oluşan müşteri ve admin hata referansları.",
    "ülke": "ülke",
    "Ülke": "Ülke",
    "Ürün": "Ürün",
    "Ürün adı": "Ürün adı",
    "Ürün bilgileri": "Ürün bilgileri",
    "Ürün seçin": "Ürün seçin",
    "Ürün, taşıyıcı, ağırlık ve baz fiyat bilgileri.": "Ürün, taşıyıcı, ağırlık ve baz fiyat bilgileri.",
    "Ürünler": "Ürünler",
    "Ürünü seçin ve bir veya daha fazla kaynak PDF yükleyin.": "Ürünü seçin ve bir veya daha fazla kaynak PDF yükleyin.",
    "Filtrelerden Status offen seçildiğinde teslim edildi veya yolda olmayan açık DHL bildirimli etiketler listelenir. Not, kontrol sonucu ve zamanlar için Detay butonunu kullanın.": "Filtrelerden Status offen seçildiğinde teslim edildi veya yolda olmayan açık DHL bildirimli etiketler listelenir. Not, kontrol sonucu ve zamanlar için Detay butonunu kullanın.",
    "Kaynak dosya": "Kaynak dosya",
    "Kaynak ID": "Kaynak ID",
    "Kullanıma aç": "Kullanıma aç",
    "Sorun / not": "Sorun / not",
    "Void kaynak etiketleri": "Void kaynak etiketleri",
    "Yedek etiket": "Yedek etiket",
    "Yüklendi": "Yüklendi",
    "Atandı": "Atandı",
    "Varsayılan yap": "Varsayılan yap",
    "Vazgeç": "Vazgeç",
    "Vergi no": "Vergi no",
    "Vergi oranı": "Vergi oranı",
    "Veri kaynağı": "Veri kaynağı",
    "Versand- und Logistikdienstleistung": "Nakliye ve lojistik hizmetleri",
    "Video linki admin ortam değişkenine eklendiğinde burada açılacak.": "Video linki admin ortam değişkenine eklendiğinde burada açılacak.",
    "Videoyu aç": "Videoyu aç",
    "Vite production derlemesi geçiyor": "Vite production derlemesi geçiyor",
    "Void gönderiler ve bağlı etiketlerin güncel konumu.": "İptal edilen gönderiler ve bağlı etiketlerin güncel konumu.",
    "Wenn ein Verifizierungslink gesendet wurde, finden Sie ihn im Posteingang.": "Bir doğrulama bağlantısı gönderildiyse, bunu gelen kutunuzda bulacaksınız.",
    "Yazdırıldı": "Yazdırıldı",
    "Yazdırılma/Gönderim": "Yazdırılma/Gönderim",
    "Yeni ekip üyesi": "Yeni ekip üyesi",
    "Yeni mağaza": "Yeni mağaza",
    "Yeni müşteri": "Yeni müşteri",
    "Yeni plan": "Yeni plan",
    "Yeni Sipariş Oluştur": "Yeni Sipariş Oluştur",
    "Yeni şifre": "Yeni şifre",
    "Yeni şifre tekrar": "Yeni şifre tekrar",
    "Yeni ürün": "Yeni ürün",
    "Yeniden bağla": "Yeniden bağla",
    "Yönetim": "Yönetim",
    "Yolda": "Yolda",
    "Yönlendirilen": "Yönlendirilen",
    "Yönlendirilen müşteriler": "Yönlendirilen müşteriler",
    "Yükle": "İndirmek",
    "Yükleme": "Yükleme",
    "Yüklenen ve müşterilere atanan son kaynak etiketleri.": "Yüklenen ve müşterilere atanan son kaynak etiketleri.",
    "Yükleniyor": "Yükleniyor",
    "Yüksek": "Yüksek",
    "ZIP export": "Posta kodunu dışa aktarma",
    "ZIP paket": "Posta paketi",
    "Shopware 6 Admin API ile siparişlerinizi alın ve oluşturulan takip numaralarını doğru teslimata geri yazın.": "Shopware 6 Admin API ile siparişlerinizi alın ve oluşturulan takip numaralarını doğru teslimata geri yazın.",
    "Shopware mağazanızın ana adresi. /api eklemeyin.": "Shopware mağazanızın ana adresi. /api eklemeyin.",
    "Aynı entegrasyona ait Secret Access Key. Bu değer ekranda tekrar gösterilmez.": "Aynı entegrasyona ait Secret Access Key. Bu değer ekranda tekrar gösterilmez.",
    "Shopware 6 mağaza URL'si": "Shopware 6 mağaza URL'si",
    "Sipariş okuma ve teslimat güncelleme yetkisi": "Sipariş okuma ve teslimat güncelleme yetkisi",
    "Shopware yönetiminde KenPost için bir entegrasyon oluşturun.": "Shopware yönetiminde KenPost için bir entegrasyon oluşturun.",
    "Bağlantı doğrulandıktan sonra 30 dakikalık sipariş senkronunu başlatın.": "Bağlantı doğrulandıktan sonra 30 dakikalık sipariş senkronunu başlatın.",
    "Shopware mağazasını bağla": "Shopware mağazasını bağla",
    "Shopware mağaza URL": "Shopware mağaza URL",
    "Shopware bağlantısı doğrulanamadı.": "Shopware bağlantısı doğrulanamadı.",
    "Takip sonrası gönderildi yap": "Takip sonrası gönderildi yap"
  },
  "en": {
    "· stok": "· stock",
    "100 takip senkronla": "100 follow syncs",
    "194 mevcut, 92 kısmi, 15 eksik": "194 present, 92 partial, 15 missing",
    "30.05.2026 Kenpost Version 2 geçişi": "30.05.2026 Kenpost Version 2 transition",
    "AboutYou adı": "AboutYou name",
    "aç": "hungry",
    "Açık olduğunda girişte e-posta doğrulama kodu istenir.": "When turned on, you will be asked for an email verification code upon login.",
    "Açık siparişler": "open orders",
    "Açıklama": "Explanation",
    "Admin": "Admin",
    "Admin destek modu:": "Admin support mode:",
    "Admin fatura düzenleme": "Admin invoice editing",
    "Admin panele dön": "Return to admin panel",
    "Admin paneli": "Admin panel",
    "Admin profil ve şifre ayarları.": "Admin profile and password settings.",
    "Admin URL": "Admin URL",
    "Admin, müşteri ve alt müşteri rolleri ayrıldı": "Admin, customer and sub-customer roles are separated",
    "Admin, müşteriye birden fazla etiket ürününü tek işlemde tanımlar; her satır ayrı ürün olarak faturaya yazılır.": "Admin defines multiple label products to the customer in one operation; Each line is written on the invoice as a separate product.",
    "Adobe PDF": "Adobe PDF",
    "Adres 1": "Address 1",
    "Adres 2": "Address 2",
    "Yazdığım adresle devam et": "Continue with typed address",
    "Adres kaynağı": "Address source",
    "Adres kaynağı belirsiz": "Address source unknown",
    "Affiliate bilgileri yükleniyor": "Affiliate information is loading",
    "Affiliate hesapları": "Affiliate accounts",
    "Affiliate linkinizle gelen müşteriler ve kullanım başına oluşan komisyonlar.": "Customers coming through your affiliate link and commissions per use.",
    "Affiliate profilleri": "Affiliate profiles",
    "Affiliate programı": "Affiliate program",
    "Affiliate tahakkuk ve ödeme hareketleri.": "Affiliate accrual and payment transactions.",
    "Affiliate ve kazançlar": "Affiliate & earnings",
    "Ağırlığa göre otomatik etiket": "Automatic label by weight",
    "Ağırlık": "Weight",
    "Ağırlık aralığı": "Weight range",
    "Aktif etiket ürünü bulunamadı. Önce etiket ürünü tanımlayın veya ürünü aktif hale getirin.": "No active label product found. First identify the label product or activate the product.",
    "Aktif fiyat ve stok bilgileri satın alma ekranında gösterilir.": "Active price and stock information is displayed on the purchase screen.",
    "Aktif hesap": "active account",
    "Aktif kurallar": "Active rules",
    "Aktif ve pasif planlar.": "Active and passive plans.",
    "Aktiflik, e-posta, mağaza ve etiket bakiyesi kontrolü.": "Activity, e-mail, store and label balance control.",
    "alıcı": "buyer",
    "Alıcı": "Buyer",
    "Alıcı adı": "Recipient name",
    "Alıcı ve adres": "Recipient and address",
    "Alt müşteri": "Sub-customer",
    "Alt müşteri hesaplarını, erişim durumlarını ve son giriş hareketlerini yönetin.": "Manage sub-customer accounts, access statuses and recent login activities.",
    "Alt müşteriler": "Sub-customers",
    "Altı aydan eski, kullanılmamış ve stoktan düşürülmüş etiketler.": "Labels that are more than six months old, unused and removed from stock.",
    "Amazon bağlantısını server link akışıyla başlatın; siparişler Shopify kaynak senkronundan alınır.": "Start the Amazon connection with the server link flow; orders are fetched from the Shopify source sync.",
    "Amazon bağlantısını yönet": "Manage Amazon link",
    "Amazon mağaza adı": "Amazon store name",
    "Amazon mağazası bağla": "Connect Amazon store",
    "Amazon onay linkini aç": "Open Amazon verification link",
    "Amazon yetkilendirmeyi başlat": "Start Amazon authorization",
    "Etsy bağlantısını server link akışıyla başlatın; siparişler Shopify kaynak senkronundan alınır.": "Start the Etsy connection with the server link flow; orders are fetched from the Shopify source sync.",
    "Etsy mağaza adı": "Etsy store name",
    "Etsy mağazası bağla": "Connect Etsy store",
    "Etsy onay linkini aç": "Open Etsy verification link",
    "Etsy yetkilendirmeyi başlat": "Start Etsy authorization",
    "Sistem şu an meşgul. Başka bir Amazon/Etsy bağlantısı çalışıyor; birkaç dakika sonra tekrar deneyin.": "The system is busy. Another Amazon/Etsy connection is running; please try again in a few minutes.",
    "Ana mağaza": "main store",
    "API anahtarı": "API key",
    "API kullanıcı": "API user",
    "API şifre": "API password",
    "Ara servis": "intermediate service",
    "Arama ve durum filtresi aktif": "Search and status filter active",
    "Atanmış etiket kaynakları.": "Assigned label resources.",
    "Atanmamış": "Unassigned",
    "ayrı listeyi aç": "open separate list",
    "Ayrıştır": "parse",
    "Ayrım": "Category",
    "Bağla": "Connect",
    "Bağlamak istediğiniz satış kanalını seçin.": "Select the sales channel you want to connect.",
    "Bağlantı": "Connection",
    "Bağlantı başlat": "start connection",
    "Bağlantı bilgileri": "Connection information",
    "Bağlantı bilgileri güvenli şekilde saklanır. Gizli alanlar gösterilmez; yeni değer girilirse güncellenir, boş bırakılırsa mevcut değer korunur.": "Connection information is stored securely. Hidden fields are not shown; If a new value is entered, it is updated; if left blank, the current value is preserved.",
    "Bağlantı durumu": "connection status",
    "Bağlantı modu (connector/ip)": "Connection mode (connector/ip)",
    "Bağlantıyı kapat": "close connection",
    "Bağlantıyı tamamla": "Complete the connection",
    "Bağlantıyı test et": "Test the connection",
    "Bağlı mağaza yok.": "There are no affiliated stores.",
    "Bağlı mağazalar": "affiliated stores",
    "Bağlı satış kanalları ve entegrasyon özeti.": "Connected sales channels and integration summary.",
    "Bakım penceresinde tekrar çalışacak": "It will work again in the maintenance window",
    "Bakım penceresinde yeniden import": "Re-import in the maintenance window",
    "Başarı oranı": "Success rate",
    "Başarılı": "Successful",
    "Başlamadı": "Did not start",
    "Başlangıç": "Beginning",
    "Başlangıç durumu yükleniyor": "Loading initial state",
    "Başlangıç şifresi": "initial password",
    "Baz fiyat": "base price",
    "Baz fiyat:": "Base price:",
    "Bekleyen ödeme": "pending payment",
    "Bilinmiyor": "Unknown",
    "Billbee adı": "billbee name",
    "Birden fazla ürün/hizmet satırını tek faturada toplayıp PDF üretin.": "Collect multiple product/service lines in a single invoice and produce PDF.",
    "Birim brüt": "unit gross",
    "Birim fiyat": "unit price",
    "Birim net": "unit net",
    "Brüt toplam": "Gross total",
    "Bu manuel Shopify faturası iptal edilecek. Devam edilsin mi?": "This manual Shopify invoice will be cancelled. Continue?",
    "Bitiş": "Finish",
    "Bize ulaşın": "Contact us",
    "Bonus işaretlenen satırlar 0 EUR tutulur ve otomatik fiyat tamiri bu kayıtları ücretlendirmez.": "Bonus marked lines are kept at 0 EUR and automatic price repair does not charge these records.",
    "Bonus/telafi etiketi": "Bonus/compensation label",
    "Brüt": "Gross",
    "Girilen tutar nettir; KDV seçilen orana göre üzerine eklenir.": "The entered amount is net; VAT is added according to the selected rate.",
    "KDV": "VAT",
    "Manuel Shopify faturası iptal edilemedi.": "The manual Shopify invoice could not be cancelled.",
    "Net toplam": "Net total",
    "Bu değerler mevcut fatura PDF ve admin manuel fatura akışlarında kullanılır.": "These values ​​are used in existing invoice PDF and admin manual invoice flows.",
    "Bu etiket status bakmadan admin stok havuzuna alınacak. Etiket artık kullanıcılar tarafından satın alınabilir olacak. Devam edilsin mi?": "This label will be returned to the admin stock pool without checking status. Users will be able to buy it again. Continue?",
    "Bu filtrelerle eşleşen müşteri bulunamadı.": "No customers were found matching these filters.",
    "Bu filtrede etiket yok.": "No labels in this filter.",
    "Bu linkle kayıt olan müşteriler otomatik olarak hesabınıza bağlanır.": "Customers who register with this link are automatically connected to your account.",
    "Bu sayfa bakiye": "This page balance",
    "Bu sayfa gönderi": "This page shipment",
    "Bu sayfa mağaza": "This page store",
    "Bu sipariş Packstation/Postfiliale adresli. Etiket oluşturmak için normal teslimat adresi girin.": "This order uses a Packstation/Postfiliale address. Enter a normal delivery address to create a label.",
    "Bu sipariş Packstation/Postfiliale adresli. Toplu işlemde seçilmez; tekli etiket oluşturabilirsiniz. Packstation için Postnummer bilgisi adres içinde olmalı.": "This order uses a Packstation/Postfiliale address. It is not selectable in bulk; you can create a single label. Packstation orders must include the Postnummer in the address.",
    "Bu sipariş için gönderi yok.": "There is no shipping for this order.",
    "Bu siparişe bağlı gönderiler": "Shipments related to this order",
    "Bugün": "Today",
    "Bugün Berlin saatiyle 18:00-23:59 arasında sistem kapalı olacaktır. Geçişten sonra yeni sistemimiz ve son özelliklerimizle tekrar karşınızda olacağız.": "The system will be closed today between 18:00 and 23:59 Berlin time. After the transition, we will be back with our new system and latest features.",
    "Bugünkü gönderi ritmini ve hesabın dikkat isteyebileceği alanlarını hızlıca okuyun.": "Quickly read today's posting cadence and areas of the account that may need attention.",
    "Cache boyutu": "Cache size",
    "Checkout'u aç": "Open checkout",
    "Cloudflare D1 içinde müşteri hesabı oluşturur.": "Creates a customer account in Cloudflare D1.",
    "Cloudflare sürüm ve audit özeti.": "Cloudflare version and audit summary.",
    "Cloudflare taşıma sürüm ve audit durumu.": "Cloudflare migration version and audit status.",
    "Cloudflare uygulaması": "Cloudflare app",
    "CSV export": "CSV export",
    "CSV, TSV veya XLSX dosyasındaki adresleri manuel etikete çevirin.": "Convert addresses from CSV, TSV or XLSX file into manual labels.",
    "Carrier durum": "Carrier status",
    "Packstation/Postfiliale adresleri bu internal DHL etiket akışında desteklenmiyor.": "Packstation/Postfiliale addresses are not supported in this internal DHL label flow.",
    "Packstation/Postfiliale adresleri bu işlemde toplu veya manuel oluşturulamaz. Lütfen sipariş satırındaki tekli etiket oluşturmayı kullanın.": "Packstation/Postfiliale addresses cannot be created through this bulk or manual flow. Please use single-label creation on the order row.",
    "Packstation/Postfiliale adresleri toplu etiket işleminde seçilemez. Tekli etiket oluşturmayı kullanın.": "Packstation/Postfiliale addresses cannot be selected in bulk label creation. Use single-label creation.",
    "Packstation/Postfiliale adresli siparişler toplu etiket işlemine seçilemez; normal teslimat adresiyle tekli işlem yapılmalı.": "Orders with Packstation/Postfiliale addresses cannot be selected for bulk labels; use a normal delivery address in the single-label flow.",
    "Packstation/Postfiliale adresli siparişler toplu etiket işlemine seçilemez; tekli etiket oluşturmayı kullanın.": "Orders with Packstation/Postfiliale addresses cannot be selected for bulk labels; use single-label creation.",
    "Bu gönderi zaten iptal edilmiş veya kapalı.": "This shipment is already cancelled or closed.",
    "Bu gönderi iptal edilemez: DHL/taşıyıcı hareketi görünüyor. Etiket krediye iade edilmedi.": "This shipment cannot be cancelled: DHL/carrier movement is visible. The label was not returned to credit.",
    "Bu gönderi iptal edilemez: taşıyıcı durumu güvenli şekilde Status offen / hareket yok olarak doğrulanamadı.": "This shipment cannot be cancelled: the carrier status could not be safely verified as Status offen / no movement.",
    "Etiket iptal edildi; kredi bakiyenize geri döndü ve sipariş tekrar etiket bekliyor.": "The label was cancelled; the credit returned to your balance and the order is waiting for a label again.",
    "Etiket/gönderi iptal edilsin mi?": "Cancel label/shipment?",
    "Etiket kredisi stoğa geri döner ve sipariş tekrar etiket bekleyen duruma alınır.": "The label credit returns to stock and the order is moved back to waiting for a label.",
    "Gönderi iptal edilsin mi?": "Cancel shipment?",
    "Gönderi iptal edildi; etiket kredisi hesabınıza geri döndü ve sipariş tekrar etiket bekliyor.": "Shipment cancelled; the label credit returned to your account and the order is waiting for a label again.",
    "Gönderi kaydı bulunamadı.": "Shipment record not found.",
    "Gönderiyi iptal et": "Cancel shipment",
    "İptal başarılı olursa etiket kredisi müşteri bakiyesine geri döner ve sipariş tekrar etiket bekleyen duruma gelir.": "If cancellation succeeds, the label credit returns to the customer balance and the order waits for a label again.",
    "Sadece DHL hareketi olmayan / Status offen etiketler iptal edilebilir.": "Only labels with no DHL movement / Status offen can be cancelled.",
    "Seçili gönderiler iptal edilsin mi?": "Cancel selected shipments?",
    "Teknik hata kayıtları müşteri iptaliyle krediye alınamaz.": "Technical error records cannot be returned to credit through customer cancellation.",
    "Çıkış": "Sign out",
    "D1 snapshot": "D1 snapshot",
    "Değer": "Value",
    "Değişim": "Change",
    "Destek": "Support",
    "Detay": "Details",
    "Destek merkezi": "support center",
    "Destek raporu yükleniyor": "Support report loading",
    "Destek talebi": "support request",
    "Destek talebi yok.": "No support requests.",
    "Destek talepleri admin rapor ekranına referans numarasıyla düşer.": "Support requests appear on the admin report screen with a reference number.",
    "Desteklenen pazar yerleri": "Supported marketplaces",
    "Devre dışı": "disabled",
    "DHL hata": "DHL even",
    "DHL hata oranı": "DHL error rate",
    "DHL kontrol": "DHL control",
    "DHL kontrol özeti": "DHL check summary",
    "DHL kontrol performansı": "DHL control performance",
    "DHL taşıyıcı kontrol sonuçları ve hatalı/şüpheli etiket sinyalleri.": "DHL carrier check results and faulty/suspicious label signals.",
    "DHL event timeline": "DHL event timeline",
    "DHL takip sayfasını yeni sekmede aç": "Open DHL tracking page in a new tab",
    "DHL/taşıyıcı kontrol kuyrukları ve sonuç özetleri.": "DHL/carrier check queues and result summaries.",
    "Dış servis ihtiyacı": "Foreign service need",
    "Dış kullanım": "External usage",
    "Dışa aktarım": "Export",
    "Diğer": "Other",
    "Durum": "Status",
    "Doğrulama bekleyen": "Pending verification",
    "Doğrulanmış": "verified",
    "dosya işlendi": "file processed",
    "Dosya seç": "select file",
    "Durumu yenile": "Refresh status",
    "Düzenle": "Edit",
    "E-Mail prüfen": "Check email",
    "E-posta 2FA": "Email 2FA",
    "E-posta adresi": "E-mail adresi",
    "E-posta doğrulama": "Email verification",
    "E-posta ile ikinci doğrulama.": "Second verification by email.",
    "eBay bağla": "connect to eBay",
    "eBay bağlantıları": "eBay links",
    "eBay bağlantısı yok.": "There is no link to eBay.",
    "eBay hesabınızı güvenli bağlantı akışıyla ekleyin.": "Add your eBay account via secure connection flow.",
    "eBay mağazası bağla": "Connect eBay store",
    "eBay OAuth": "eBay OAuth",
    "eBay OAuth başlat": "Start eBay OAuth",
    "eBay ortamı": "eBay environment",
    "eBay yeniden bağla": "eBay reconnect",
    "Eğitim videoları": "Training videos",
    "Eğitimler": "Training",
    "Eğitimler yükleniyor": "Trainings are loading",
    "Ekibiniz için sınırlı müşteri hesabı oluşturun.": "Create limited customer accounts for your team.",
    "Ekip üyeleri": "team members",
    "Ekip üyeleri yükleniyor": "Team members loading",
    "Ekip üyesi yok.": "There are no team members.",
    "Ekip yönetimi": "Team management",
    "Eksik/hatalı etiketler": "Missing/incorrect labels",
    "empfänger": "recipient",
    "Eski sistemdeki temel store ayarları ve platform credential bilgileri.": "Basic store settings and platform credential information in the old system.",
    "Eski veya yanlış faturaların toplu otomatik düzeltilmesi ayrıca ele alınacak.": "Bulk auto-correction of old or incorrect invoices will be covered separately.",
    "Etiket / indirme": "Label / download",
    "Etiket bakiyeleri": "Label balances",
    "Etiket bakiyesi": "Label balance",
    "Etiket bakiyesi ve faturalar": "Label balance and invoices",
    "Etiket bakiyesi yok.": "There is no label balance.",
    "Etiket bilgileri yükleniyor": "Label information is loading",
    "Etiket çıktısı": "Label printout",
    "Etiket durumu": "Label status",
    "Etiket Envanteri": "Label inventory",
    "Etiket envanteri": "Label inventory",
    "Etiket envanteri ve faturalama": "Label inventory and invoicing",
    "Hatalı Etiketler": "Faulty labels",
    "Hatalı etiket detayı": "Faulty label details",
    "Hatalı etiket yok.": "No faulty labels.",
    "Hatalı etiketler alınamadı.": "Could not load faulty labels.",
    "Hatalı etiketler yükleniyor": "Loading faulty labels",
    "Müşteri İptalleri": "Customer cancellations",
    "Taşıyıcı Kontrol Hataları": "Carrier check errors",
    "Etiket kaynağı yükle": "Upload label source",
    "Etiket Kontrolleri": "Label checks",
    "Etiket kontrolleri": "Label controls",
    "Etiket kredi sepeti": "Label credit cart",
    "Etiket kredilerini checkout ile satın alın ve ödeme sonrası bakiyeye işleyin.": "Purchase label credits upon checkout and apply to the balance after payment.",
    "Etiket oluştur": "Create label",
    "Etiket oluşturma": "Create a label",
    "Etiket oluştu": "Label created",
    "Etiket paketleri": "sticker packs",
    "Etiket sağlayıcı": "Label provider",
    "Etiket satın al": "Buy labels",
    "Etiket Satın Al": "Buy Label",
    "Etiket satın alma": "buy labels",
    "Etiket satın alma faturaları": "Label purchase invoices",
    "Etiket satın almaları": "Label purchases",
    "Etiket Ürünleri": "Label products",
    "Etiket ürünleri için müşteri bazlı fiyat tanımları.": "Customer-based price definitions for label products.",
    "Etiket ürünleri yükleniyor": "Label products loading",
    "Etiket ürünleri, stok hareketleri ve taşıyıcı kontrolleri.": "Label products, stock movements and carrier controls.",
    "Etiket ürünü": "label product",
    "Etiket ürünü yok": "No label product",
    "Etiket ürünü yükleniyor": "Label product loading",
    "Etiket verileri yükleniyor": "Loading label data",
    "Etikete dönüştürülmeye hazır": "Ready to be converted into labels",
    "Etiketi oluştur": "Create the label",
    "Etiketler": "Labels",
    "Etiketlere dön": "Back to labels",
    "Etikette SKU": "Label SKU",
    "Etiket kullanıma açılamadı.": "Could not release label to available.",
    "etiketürünü": "labelproduct",
    "export dosyasına yazıldı": "written to export file",
    "Fatura / ödeme": "Invoice / payment",
    "Fatura adresi": "Billing address",
    "Fatura adresi farklı": "Billing address differs",
    "Fatura adresi yedeği": "Billing fallback",
    "Fatura ayarları": "Invoice settings",
    "Fatura bilgileri": "Billing Information",
    "Fatura durumu": "Invoice status",
    "Fatura posta kodu": "Billing postal code",
    "Fatura satırı yok.": "There is no invoice line.",
    "Fatura şehir": "bill city",
    "Fatura toplamı": "Invoice total",
    "Fatura ülke": "Invoice country",
    "Fatura ve etiket satın alma kayıtları.": "Invoice and label purchase records.",
    "Fatura ve gönderici adresi": "Billing and shipper address",
    "Fatura ve gönderici bilgileri": "Billing and sender information",
    "Fatura yok.": "There is no invoice.",
    "Faturalama": "Billing",
    "Faturalama verisi yükleniyor": "Loading billing data",
    "Faturalar": "Invoices",
    "Faturalar, PDF üretimi ve etiket satın alma faturaları.": "Invoices, PDF production and label purchase invoices.",
    "Faturalara dön": "Back to invoices",
    "Final eşitleme": "final equalization",
    "Final senkron": "Final synchronous",
    "Fiyat matrisi": "Price matrix",
    "Fiyatları aç": "Open prices",
    "Gadget kapatma": "Gadget shutdown",
    "Gadget tarafındaki server link senaryosuyla aynı başlat/onayla akışını kullanır.": "It uses the same initialize/confirm flow as the server link scenario on the gadget side.",
    "Geçiş planı": "transition plan",
    "Genel Bakış": "Overview",
    "Genel not": "Genel not",
    "Gizli anahtar": "Secret key",
    "Gönder": "Send",
    "Gönderen adı": "Sender name",
    "Gönderi": "Shipment",
    "Gönderi başarı oranı": "Shipment success rate",
    "Gönderi bilgileri": "Shipping information",
    "Gönderi bilgisi": "Shipment information",
    "Gönderi bulunamadı": "Shipment not found",
    "Gönderi detayı açılamadı": "Shipment details could not be opened",
    "Gönderi detayı yükleniyor": "Shipment detail loading",
    "Gönderi tipi": "Shipment type",
    "Gönderi yok.": "No shipments.",
    "Gönderici adı": "Sender name",
    "Gönderici adresi": "Sender address",
    "Gönderici posta kodu": "Sender postal code",
    "Gönderici şehir": "Sender city",
    "Gönderici ülke": "Sending country",
    "Gönderiler": "Shipments",
    "Gönderiler yükleniyor": "Shipments are loading",
    "Gönderilere dön": "Back to shipments",
    "Gönderim": "Transfer",
    "gönderitipi": "posttype",
    "Görünen DHL etiketlerini kontrol et": "Check for visible DHL labels",
    "Gün": "Day",
    "Güncelleme": "Update",
    "Günlük destek raporu yok.": "There are no daily support reports.",
    "Günlük teknik talep raporu": "Daily technical demand report",
    "Güvenlik": "Security",
    "Hareketli / kullanılmış": "Moving / used",
    "Harici sipariş": "external order",
    "Hata kayıtları": "Error logs",
    "Hata kayıtları ve arka plan işlem izleri.": "Error logs and background process traces.",
    "Hatalı": "Incorrect",
    "Hazır": "Ready",
    "Hazır etiketler": "Ready made labels",
    "Hazır stok:": "Ready stock:",
    "Hazırlık durumu": "Readiness status",
    "Henüz affiliate profiliniz yok.": "You don't have an affiliate profile yet.",
    "Henüz ekip üyesi yok.": "There are no team members yet.",
    "Henüz hazır değil": "not ready yet",
    "Henüz mağaza yok.": "There are no stores yet.",
    "Henüz referans kaydı yok.": "There are no reference records yet.",
    "Henüz sipariş yok.": "No orders yet.",
    "Her şey yolunda": "Everything is running well",
    "Hesaba geç": "Switch to account",
    "Hesap": "Account",
    "Hesap aktif": "Account active",
    "Hesap aktif.": "Account is active.",
    "Hesap bilgileri": "Account information",
    "Hesap güvenliği": "Account security",
    "Hesap hazır": "Account is ready",
    "Hesap hazırlığı": "Account preparation",
    "Hesap şifrenizi güvenli şekilde güncelleyin.": "Update your account password securely.",
    "Hızlı yönetim": "Fast management",
    "Hareket yok": "No movement",
    "Importu oluştur": "Create import",
    "İade": "Return",
    "İade sinyali": "return signal",
    "İç platformlar": "interior platforms",
    "İç servis": "internal service",
    "İptal": "Cancel",
    "İptal edilen etiketler": "Canceled labels",
    "İptal kayıtları": "Cancellation records",
    "İstemci anahtarı": "client key",
    "İstemci gizli anahtarı": "Client secret",
    "İstemci ID": "Client ID",
    "İstenen": "desired",
    "İşlem": "Action",
    "JTL DB adı": "JTL DB name",
    "JTL DB kullanıcı": "JTLDB user",
    "JTL DB port": "JTL DB port",
    "JTL DB sunucu": "JTL DB server",
    "JTL DB şifre": "JTL DB password",
    "JTL siparişinde ağırlık bilgisi gelmedi. Yanlış ürün seçilmemesi için etiket ürününü manuel seçin.": "This JTL order has no weight information. Select the label product manually to avoid choosing the wrong product.",
    "JTL URL": "JTL URL",
    "Katıldığınızda size özel referans kodu ve kayıt linki oluşur.": "When you join, you will receive a special reference code and registration link.",
    "Kaydet ve PDF üret": "Save and generate PDF",
    "Kaydedilmiş DHL event yok.": "No saved DHL events.",
    "Kayıt": "Record",
    "Kayıt bulunamadı.": "No record found.",
    "Kayıt linki": "Registration link",
    "Kapat": "Close",
    "Kayıt yok.": "No record.",
    "Kayıtlı": "Registered",
    "Kaynak platform senkronu": "Source platform synchronization",
    "Kaynak platforma takip gönder": "Send follow to source platform",
    "Kaynak senkron": "source synchronous",
    "Kargo adresi": "Shipping address",
    "Kargo adresinden farklı": "Different from shipping address",
    "Kalan": "Remaining",
    "KDV %19": "VAT 19%",
    "KDV, numara formatı ve kredi faturası kuralları.": "VAT, number format and credit invoice rules.",
    "Kenpost ana sayfa": "Kenpost home",
    "Kenpost fatura numaraları, KDV oranı ve kredi faturası kuralları.": "Kenpost invoice numbers, VAT rate and credit invoice rules.",
    "Kenpost operasyon verisi": "Kenpost operation data",
    "Kenpost yeni panel": "Kenpost new panel",
    "Kimlik bilgisi": "credentials",
    "Komisyon hareketi yok.": "There is no commission movement.",
    "Komisyon hareketleri": "Commission transactions",
    "Komisyon ve bonus": "Commissions & bonuses",
    "Kontrol çalışmaları": "Control studies",
    "Kontrol edilen": "controlled",
    "Kontrol paneli": "Dashboard",
    "Kontrol paneli açılamadı": "Could not open control panel",
    "Konu ve mesajı yazın; ekip bu referansla takip eder.": "Type the subject and message; The team follows up with this reference.",
    "Kredi Durumu": "Credit Status",
    "Kredi faturası": "credit invoice",
    "Kredileri işle ve faturala": "Process and invoice loans",
    "Kullanıcı": "User",
    "Kullanıcı adı": "Username",
    "Kullanıcı eğitim ve Almanca etiket indirme içerikleri.": "User training and German label download contents.",
    "Kullanıcı video eğitimleri ve Almanca etiket indirme anlatımları.": "User video tutorials and label download instructions in German.",
    "Kullanılabilir etiket": "Available label",
    "Kullanılabilir etiketler": "Available labels",
    "Kullanılan kod": "code used",
    "kullanıma açıldı.": "released to available.",
    "Kullanım": "Use",
    "Label hatası": "Label error",
    "Linki kopyala": "copy link",
    "Mağaza": "Store",
    "Mağaza adı": "Store name",
    "Mağaza aktif": "Store active",
    "Mağaza ayarları": "Store settings",
    "Mağaza bağlantıları": "Store links",
    "Mağaza bağlantısı": "Store link",
    "Mağaza hareketlerini, etiket hazır durumunu ve gönderi temposunu tek yerden takip edin.": "Track store movements, label readiness status and shipping tempo in one place.",
    "Mağaza oluştur": "Create store",
    "Mağaza URL": "Store URL",
    "Mağaza yükleniyor": "Store loading",
    "Mağazalar": "Stores",
    "Mağazalar yükleniyor": "Stores are loading",
    "Henüz aktif mağaza yok.": "There are no active stores yet.",
    "Pasif mağazalar": "Inactive stores",
    "Pasif mağazalar ana listeden ayrılır; geçmiş ve yeniden aktifleştirme erişimi korunur.": "Inactive stores are kept outside the main list while preserving their history and reactivation access.",
    "Pasif mağazaları gizle": "Hide inactive stores",
    "Pasif mağazaları göster": "Show inactive stores",
    "Mağazalara dön": "Back to stores",
    "Mağazalara git": "Go to stores",
    "Mağazalarım": "My Stores",
    "mağazasında fulfillment/tracking kaydını yeniden dener.": "Retries the fulfillment/tracking record in its store.",
    "MAK{yıl}-{satın alma id}": "MAK{year}-{purchase id}",
    "Manuel fatura oluştur": "Create manual invoice",
    "Max gram": "Max gram",
    "Max Mustermann Musterstr. 12 10115 Berlin": "Max Mustermann Musterstr. 12 10115 Berlin",
    "Menüyü aç": "Open menu",
    "Menüyü kapat": "Close menu",
    "Mevcut snapshot import edildi": "Current snapshot imported",
    "Mevcut şifre": "Current Password",
    "Min gram": "My gram",
    "Müşteri": "Customer",
    "Müşteriye bağlı": "Linked to customer",
    "Müşteri bulunamadı": "Customer not found",
    "Müşteri detayı açılamadı": "Could not open customer details",
    "Müşteri detayı yükleniyor": "Customer details loading",
    "Müşteri etiket bakiyeleri.": "Customer label balances.",
    "Müşteri fiyatları": "Customer prices",
    "Müşteri hesabını oluşturmak için temel bilgileri girin.": "Enter basic information to create the customer account.",
    "Müşteri hesapları hazırlanıyor": "Customer accounts are being prepared",
    "Müşteri hesaplarını, mağaza bağlantılarını, etiket bakiyelerini ve destek geçişlerini tek ekrandan yönetin.": "Manage customer accounts, store links, label balances and support passes from a single screen.",
    "Müşteri Kontrol Merkezi": "Customer Control Center",
    "Müşteri olarak gör": "See as customer",
    "Müşteri oluştur": "Create customer",
    "Müşteri paneli": "Customer panel",
    "Müşteri plan kayıtları ve abonelik segmentleri.": "Customer plan enrollments and subscription segments.",
    "Müşteri seç": "select customer",
    "Müşteri teknik destek talepleri, günlük rapor ve öncelikli kayıtlar.": "Customer technical support requests, daily reports and priority records.",
    "Müşteri teknik talepleri ve günlük rapor.": "Customer technical requests and daily report.",
    "Müşteri ve alt müşteri yönetimi": "Customer and sub-customer management",
    "Müşteri ve sistem hata referansları.": "Customer and system error references.",
    "Müşteri, şirket veya e-posta ara": "Search for customer, company or email",
    "Müşteriler": "Customers",
    "Müşterilere dön": "Return to customers",
    "Müşteriye atanabilecek yeni plan tanımı oluşturun.": "Create a new plan definition that can be assigned to the customer.",
    "myshopify.com domaini": "myshopify.com domains",
    "Object key:": "Object key:",
    "olarak müşteri panelindesiniz.": "You are in the customer panel.",
    "Oluştur": "Create",
    "Oluşturulan gönderi ve etiket kayıtları; arama, sayfalama ve arka plan takip senkronu ile hızlı yönetim.": "Created shipment and label records; Fast management with search, paging and background monitoring synchronization.",
    "Oluşturuldu": "Created",
    "Oluşturulma": "Creation",
    "Onboarding açılamadı": "Onboarding could not be opened",
    "Online seller prefix": "Online seller prefix",
    "Operasyon Nabzı": "Operation Pulse",
    "Operasyon notu": "Operation note",
    "Açık olduğunda sistem bu mağazadan siparişleri arka planda düzenli çeker.": "When enabled, the system regularly pulls orders from this store in the background.",
    "Arama": "Search",
    "Atlandı": "Skipped",
    "Çalışıyor": "Running",
    "Filtrele": "Filter",
    "Günde bir": "Once a day",
    "Hata sayısı": "Error count",
    "Hatalar": "Errors",
    "Kontrol raporu": "Check report",
    "Kontrol geçmişi": "Check history",
    "Kontrol mesajı": "Check message",
    "Kontrol raporu alınamadı.": "The check report could not be loaded.",
    "Kontrol raporu yükleniyor": "Loading check report",
    "Kontrol sıklığı": "Check frequency",
    "Listelenen": "Listed",
    "Mağaza kontrol raporu": "Store check report",
    "Mağaza otomatik kontrol durumu": "Store automatic check status",
    "Mağaza, müşteri veya e-posta": "Store, customer, or email",
    "Otomatik kontrol": "Automatic check",
    "Otomatik sipariş alma": "Automatic order import",
    "Otomatik sipariş alma denemeleri, hatalar ve sıradaki kontroller.": "Automatic order import attempts, errors, and upcoming checks.",
    "Otomatik sipariş alma hataları ve sıradaki kontroller.": "Automatic order import errors and upcoming checks.",
    "Otomatik sipariş kontrolü": "Automatic order check",
    "Sıradaki kontrol": "Next check",
    "Son başarılı": "Last successful",
    "Son kontrol denemeleri": "Recent check attempts",
    "Son deneme": "Last attempt",
    "Son hata": "Last error",
    "Şimdi kontrol et": "Check now",
    "Tüm durumlar": "All statuses",
    "5 dakikada bir": "Every 5 minutes",
    "10 dakikada bir": "Every 10 minutes",
    "15 dakikada bir": "Every 15 minutes",
    "30 dakikada bir": "Every 30 minutes",
    "Saatte bir": "Hourly",
    "3 saatte bir": "Every 3 hours",
    "6 saatte bir": "Every 6 hours",
    "12 saatte bir": "Every 12 hours",
    "Operasyon, hata ve entegrasyon ayarları.": "Operation, error and integration settings.",
    "Opsiyonel URL": "Optional URL",
    "Ortam durumu": "environment status",
    "OTTO adı": "OTTO name",
    "Ödeme entegrasyonu eksik:": "Payment integration missing:",
    "Ödemeyi doğrula": "Verify payment",
    "Ödendi": "Paid",
    "Ödenen": "Paid",
    "Önbellek sipariş": "cache order",
    "Önceki": "Former",
    "Öncelik": "Priority",
    "Öncelikli": "priority",
    "Paket adedi": "Number of packages",
    "Panel bilgileri yüklenmeye hazır": "Panel information is ready to be loaded",
    "parça": "piece",
    "PayPal, Klarna, banka havalesi, SEPA ve eğitim dokümanları ödeme sağlayıcı kararından sonra bağlanacak.": "PayPal, Klarna, bank transfer, SEPA and educational documents will be connected after the payment provider decision.",
    "Pazar yeri bağlantılarınızı, sipariş senkronunu ve mağaza ayarlarını tek yerden yönetin.": "Manage your marketplace connections, order sync and store settings in one place.",
    "Pazar yeri takip yazımı, label üretimi ve iade/iptal sinyalleri.": "Marketplace tracking writing, label production and return/cancellation signals.",
    "Pazar yerine takip yazımı başarılı olan gönderiler baz alınır.": "Shipments that are successful in their follow-up writing to the marketplace are taken as basis.",
    "PDF aç": "Open PDF",
    "PDF olan": "With PDF",
    "PDF ZIP": "PDF ZIP",
    "PDF boyutu": "PDF size",
    "PDF etiket kaynaklarını D1/R2 akışına aktarır.": "Exports PDF label resources to the D1/R2 stream.",
    "PDF tarihi": "PDF history",
    "PDF yükleme": "Upload PDF",
    "Performans risk göstergeleri": "Performance risk indicators",
    "Plan adı": "Plan name",
    "Plan listesi": "Plan list",
    "Plan ve etiket satın alma durumu.": "Plan and label purchase status.",
    "Platform bağlantı bilgilerinizi güvenli şekilde ekleyin.": "Add your platform connection information securely.",
    "Platform bağlantı ve senkron özeti.": "Platform connection and sync summary.",
    "Platform bağlantıları ve raporlar": "Platform links and reports",
    "Platformlar": "Platforms",
    "Platformlardan alınan son siparişler.": "Latest orders received from the platforms.",
    "Posta kodu": "Postal code",
    "Posta kodu kontrol edilemedi.": "Postal code could not be checked.",
    "Profil": "Profile",
    "Profil yükleniyor": "Profile loading",
    "Profili kaydet": "Save profile",
    "Programa katıl": "Join the program",
    "Prüfen Sie Ihren Posteingang für den Verifizierungslink.": "Check your inbox for the verification link.",
    "R2 dosya": "R2 file",
    "Raporlar": "Reports",
    "RE-{yıl}-{sıra}": "RE-{year}-{order}",
    "Referans": "Referral",
    "Referans bağlantıları": "Referral links",
    "Referans ve kazanç": "Referrals & earnings",
    "Referans kodları, yönlendirilen müşteriler ve kullanım komisyonları.": "Referral codes, referred customers and usage commissions.",
    "Referans kodu": "Reference code",
    "Referans linki oluşturup yönlendirdiğiniz müşterilerin kullanım komisyonlarını takip edin.": "Create a reference link and track the usage commissions of the customers you refer.",
    "Referans linkiniz": "Your reference link",
    "Retoure / iade": "Return / iade",
    "Rol kapsamı": "Role scope",
    "Rol sistemi aktif": "Role system active",
    "S3 ortamı": "S3 environment",
    "Satıcı": "Seller",
    "Satın al": "buy",
    "Satın alınabilir ürün yok.": "There are no items available for purchase.",
    "Satın alma": "Purchasing",
    "Satın alma toplamı": "purchase total",
    "Satın alma yok.": "No purchases.",
    "satır": "line",
    "Satır değişiklikleri kaydedildiğinde PDF yeniden üretilir ve bağlı komisyon tutarları güncellenir.": "When row changes are saved, the PDF is regenerated and affiliate commission amounts are updated.",
    "Satır ekle": "Add row",
    "Satır notu": "liner note",
    "Satırı sil": "delete row",
    "Satırlar": "They sell",
    "Seçilen müşteri için ürün bazlı özel fiyatları düzenleyin.": "Edit product-based special prices for the selected customer.",
    "Senkron durumu": "Synchronous status",
    "Senkron sipariş": "Synchronous order",
    "Sepete satır ekle": "Add line to cart",
    "Shopify checkout bağlantılı": "Shopify checkout linked",
    "Shopify gönderim durumu": "Shopify shipping status",
    "Shopify mesajı": "Shopify message",
    "Shopify ödeme öncesi KDV davranışı Shopify checkout tarafıyla birlikte incelenecek.": "Shopify pre-payment VAT behavior will be reviewed with the Shopify checkout side.",
    "Shipment ID": "Shipment ID",
    "Sıfırla": "reset",
    "Sınırlı müşteri görünümü": "Limited customer view",
    "sipariş": "order",
    "Sipariş": "Order",
    "Sipariş bilgisi": "Order information",
    "Sipariş bulunamadı": "Order not found",
    "Sipariş detayı açılamadı": "Order details could not be opened",
    "Sipariş detayı yükleniyor": "Order detail is loading",
    "Sipariş faturası": "order invoice",
    "Sipariş listesi": "Order list",
    "Sipariş no": "Order no.",
    "Sipariş sayısı": "Number of orders",
    "Sipariş seçerek veya manuel adres girerek etiket üretin.": "Produce labels by selecting an order or manually entering an address.",
    "Sipariş seçin": "Select order",
    "Sipariş senkron servisi Cloudflare içine alınmış durumda.": "The order sync service is built into Cloudflare.",
    "Sipariş senkronu ve platform servis durumu.": "Order synchronization and platform service status.",
    "Sipariş ve gönderi operasyonları": "Order and shipment operations",
    "Sipariş ve gönderi yönetimi": "Order and shipment management",
    "Sipariş verisi": "Order data",
    "Sipariş yok.": "No order.",
    "Siparişler": "Orders",
    "Siparişler yükleniyor": "Orders are loading",
    "Siparişlere dön": "Back to orders",
    "Siparişleri al": "Receive orders",
    "Siparişleri görüntüle": "View orders",
    "siparişno": "order number",
    "Siparişten veya manuel adresten gönderi oluşturun.": "Create shipment from order or manual address.",
    "Sistemde kayıtlı çıktı": "Output saved in the system",
    "Sistemdeki sipariş kayıtları.": "Order records in the system.",
    "Site adı": "site name",
    "Son 24 saat": "Last 24 hours",
    "Son 7 gün": "last 7 days",
    "Son denetim": "Last inspection",
    "Son destek talepleri": "Latest support requests",
    "Son giriş": "last login",
    "Son giriş:": "Last entry:",
    "Son gönderiler": "Latest shipments",
    "Son hareket": "last move",
    "Son hareketler": "last movements",
    "Son hata kayıtları": "Latest error logs",
    "Son carrier event": "Last carrier event",
    "Son güncelleme": "Last update",
    "Son kayıt": "last record",
    "Son kayıtlar": "Latest records",
    "Son kaynak etiketleri": "Latest source labels",
    "Son senkron": "last sync",
    "Son siparişler": "Latest orders",
    "Sonra bakılacak notlar": "Notes to look at later",
    "Standart KDV": "Standard VAT",
    "straße": "street",
    "Süresi biten": "expired",
    "Süresi biten etiketler için": "For expired labels",
    "Süresi bitmiş etiketler": "Expired labels",
    "Sürüm": "Version",
    "Sürüm geçmişi, dağıtım versiyonu ve son ürün değişiklikleri.": "Follow release history, deployment version and the latest product changes.",
    "Sürüm Notları": "Release Notes",
    "Mevcut Ürün Sürümü": "Current Product Version",
    "Zaman Çizelgesi Kayıtları": "Timeline Entries",
    "Son Sürüm": "Latest Release",
    "Mevcut sürüm geçmişi aynı eski yapıdan okunur; yeni kayıtlar son sürümden devam eder.": "The current release history is read from the same old structure; new entries continue from the latest version.",
    "şehir": "city",
    "Şehir": "City",
    "Şehir kontrol ediliyor": "The city is controlled",
    "Şifre": "Password",
    "Şifre tekrar": "password again",
    "Şifreli alanlar boş bırakılırsa mevcut kayıt korunur.": "If encrypted fields are left blank, the existing record is preserved.",
    "Şifreyi güncelle": "Update password",
    "Şu anda kullanıma hazır": "Ready to use now",
    "Stok kaynak etiketi void durumunda.": "Source label is void.",
    "Stok kaynaklarında status=void olan etiketler. Status offen grubu teslim edildi veya yolda sinyali olmayan açık DHL bildirimlerini ayrı gösterir.": "Labels in source inventory with status=void. The Status open group separates open DHL notices that are neither delivered nor in transit.",
    "Status offen": "Status open",
    "Takip API": "Tracking API",
    "Takip": "Tracking",
    "Takip API açılamadı": "Tracking API could not be opened",
    "Takip API durumu yükleniyor": "Loading tracking API status",
    "Takip başarılı": "Tracking successful",
    "Takip bekleyen": "pending follow up",
    "Takip geri yazma": "follow back write back",
    "Takip hatalı": "Tracking is incorrect",
    "Takip hatası": "Tracking error",
    "Takip mesajı": "follow up message",
    "Takip no": "tracking number",
    "Takip no, sipariş no veya alıcı ara": "Search for tracking no., order no. or recipient",
    "Takip performansı": "Tracking performance",
    "Takip senkronu": "tracking sync",
    "Takip ve gönderi performansı": "Tracking and shipping performance",
    "Takip zamanı": "tracking time",
    "Taşıma sonrası müşteri hesabı hazırlık adımları.": "Shipment-migration customer account preparation steps.",
    "Taşıyıcı": "Carrier",
    "Taşıyıcı kontrolü": "Carrier check",
    "Taşıyıcı kontrolünde sorunlu işaretlenen etiketler.": "Labels flagged as problematic under carrier control.",
    "Tek adres kutusu": "single address box",
    "Teknik detay": "Technical details",
    "Teknik sorun": "technical problem",
    "Tekrar hoş geldin": "welcome back",
    "Temiz / açık": "clear/clear",
    "Teslim edildi": "Delivered",
    "Teslim sinyali": "surrender signal",
    "Telafi": "Remediation",
    "Telafi mesajı": "Remediation message",
    "Toplam adet": "Total quantity",
    "Toplam void": "Total void",
    "Toplam hesap": "total account",
    "Toplam: EUR": "Top lamb: EUR",
    "Toplu manuel import": "Bulk manual import",
    "Tracking sync": "Tracking sync",
    "Tüketici anahtarı": "Consumer key",
    "Tüketici gizli anahtarı": "Consumer secret",
    "Tüketilen": "consumed",
    "Tüm takip senkronları": "All follow syncs",
    "Tümü": "All",
    "Uygulama içinde oluşan müşteri ve admin hata referansları.": "Customer and admin error references occurring within the application.",
    "ülke": "country",
    "Ülke": "Country",
    "Ürün": "Product",
    "Ürün adı": "Product name",
    "Ürün bilgileri": "Product information",
    "Ürün seçin": "Select product",
    "Ürün, taşıyıcı, ağırlık ve baz fiyat bilgileri.": "Product, carrier, weight and base price information.",
    "Ürünler": "Products",
    "Ürünü seçin ve bir veya daha fazla kaynak PDF yükleyin.": "Select the product and upload one or more source PDFs.",
    "Filtrelerden Status offen seçildiğinde teslim edildi veya yolda olmayan açık DHL bildirimli etiketler listelenir. Not, kontrol sonucu ve zamanlar için Detay butonunu kullanın.": "Select Status open to list labels with open DHL notices that are neither delivered nor in transit. Use Details for notes, check results and timestamps.",
    "Kaynak dosya": "Source file",
    "Kaynak ID": "Source ID",
    "Kullanıma aç": "Release to available",
    "Sorun / not": "Issue / note",
    "Void kaynak etiketleri": "Void source labels",
    "Yedek etiket": "Replacement label",
    "Yüklendi": "Uploaded",
    "Atandı": "Assigned",
    "Varsayılan yap": "make default",
    "Vazgeç": "Cancel",
    "Vergi no": "Tax number",
    "Vergi oranı": "Tax rate",
    "Veri kaynağı": "Data source",
    "Versand- und Logistikdienstleistung": "Shipping and logistics services",
    "Video linki admin ortam değişkenine eklendiğinde burada açılacak.": "When the video link is added to the admin environment variable, it will open here.",
    "Videoyu aç": "Open video",
    "Vite production derlemesi geçiyor": "Vite production compilation is in progress",
    "Void gönderiler ve bağlı etiketlerin güncel konumu.": "Current location of cancelled shipments and linked labels.",
    "Wenn ein Verifizierungslink gesendet wurde, finden Sie ihn im Posteingang.": "If a verification link has been sent, you will find it in your inbox.",
    "Yazdırıldı": "Printed",
    "Yazdırılma/Gönderim": "Printing/Sending",
    "Yeni ekip üyesi": "new team member",
    "Yeni mağaza": "new store",
    "Yeni müşteri": "new customer",
    "Yeni plan": "new plan",
    "Yeni Sipariş Oluştur": "Create New Order",
    "Yeni şifre": "New Password",
    "Yeni şifre tekrar": "New password again",
    "Yeni ürün": "new product",
    "Yeniden bağla": "reconnect",
    "Yönetim": "Management",
    "Yolda": "In transit",
    "Yönlendirilen": "directed",
    "Yönlendirilen müşteriler": "Referred customers",
    "Yükle": "Download",
    "Yükleme": "Loading",
    "Yüklenen ve müşterilere atanan son kaynak etiketleri.": "Latest source labels uploaded and assigned to customers.",
    "Yükleniyor": "Loading",
    "Yüksek": "High",
    "ZIP export": "ZIP export",
    "ZIP paket": "ZIP package",
    "Shopware 6 Admin API ile siparişlerinizi alın ve oluşturulan takip numaralarını doğru teslimata geri yazın.": "Import your orders through the Shopware 6 Admin API and write the generated tracking numbers back to the correct delivery.",
    "Shopware mağazanızın ana adresi. /api eklemeyin.": "The base URL of your Shopware store. Do not add /api.",
    "Aynı entegrasyona ait Secret Access Key. Bu değer ekranda tekrar gösterilmez.": "The Secret Access Key for the same integration. This value is not displayed again.",
    "Shopware 6 mağaza URL'si": "Shopware 6 store URL",
    "Sipariş okuma ve teslimat güncelleme yetkisi": "Permission to read orders and update deliveries",
    "Shopware yönetiminde KenPost için bir entegrasyon oluşturun.": "Create an integration for KenPost in Shopware Administration.",
    "Bağlantı doğrulandıktan sonra 30 dakikalık sipariş senkronunu başlatın.": "After the connection is verified, start the 30-minute order synchronization.",
    "Shopware mağazasını bağla": "Connect Shopware store",
    "Shopware mağaza URL": "Shopware store URL",
    "Shopware bağlantısı doğrulanamadı.": "The Shopware connection could not be verified.",
    "Takip sonrası gönderildi yap": "Mark as shipped after adding tracking"
  },
  "de": {
    "· stok": "· Aktie",
    "100 takip senkronla": "100 Folgesynchronisierungen",
    "194 mevcut, 92 kısmi, 15 eksik": "194 vorhanden, 92 teilweise, 15 vermisst",
    "30.05.2026 Kenpost Version 2 geçişi": "30.05.2026 Kenpost Version 2 Übergang",
    "AboutYou adı": "AboutYou-Name",
    "aç": "hungrig",
    "Açık olduğunda girişte e-posta doğrulama kodu istenir.": "Wenn diese Option aktiviert ist, werden Sie beim Anmelden nach einem E-Mail-Bestätigungscode gefragt.",
    "Açık siparişler": "offene Bestellungen",
    "Açıklama": "Erläuterung",
    "Admin": "Admin",
    "Admin destek modu:": "Admin-Supportmodus:",
    "Admin fatura düzenleme": "Bearbeitung von Administratorrechnungen",
    "Admin panele dön": "Zum Adminbereich zurück",
    "Admin paneli": "Adminbereich",
    "Admin profil ve şifre ayarları.": "Admin-Profil- und Passworteinstellungen.",
    "Admin URL": "Admin-URL",
    "Admin, müşteri ve alt müşteri rolleri ayrıldı": "Die Rollen Administrator, Kunde und Unterkunde sind getrennt",
    "Admin, müşteriye birden fazla etiket ürününü tek işlemde tanımlar; her satır ayrı ürün olarak faturaya yazılır.": "Der Administrator definiert dem Kunden in einem Vorgang mehrere Etikettenprodukte. Jede Zeile wird als separates Produkt auf der Rechnung ausgewiesen.",
    "Adobe PDF": "Adobe PDF",
    "Adres 1": "Adresse 1",
    "Adres 2": "Adresse 2",
    "Yazdığım adresle devam et": "Mit eingegebener Adresse fortfahren",
    "Adres kaynağı": "Adressquelle",
    "Adres kaynağı belirsiz": "Adressquelle unbekannt",
    "Affiliate bilgileri yükleniyor": "Affiliate-Informationen werden geladen",
    "Affiliate hesapları": "Affiliate-Konten",
    "Affiliate linkinizle gelen müşteriler ve kullanım başına oluşan komisyonlar.": "Kunden, die über Ihren Affiliate-Link kommen, und Provisionen pro Nutzung.",
    "Affiliate profilleri": "Affiliate-Profile",
    "Affiliate programı": "Affiliate-Programm",
    "Affiliate tahakkuk ve ödeme hareketleri.": "Affiliate-Abgrenzungs- und Zahlungstransaktionen.",
    "Affiliate ve kazançlar": "Affiliate & Guthaben",
    "Ağırlığa göre otomatik etiket": "Automatische Etikettierung nach Gewicht",
    "Ağırlık": "Gewicht",
    "Ağırlık aralığı": "Gewichtsbereich",
    "Aktif etiket ürünü bulunamadı. Önce etiket ürünü tanımlayın veya ürünü aktif hale getirin.": "Kein aktives Label-Produkt gefunden. Identifizieren Sie zunächst das Etikettenprodukt oder aktivieren Sie das Produkt.",
    "Aktif fiyat ve stok bilgileri satın alma ekranında gösterilir.": "Aktive Preis- und Lagerbestandsinformationen werden auf dem Kaufbildschirm angezeigt.",
    "Aktif hesap": "aktives Konto",
    "Aktif kurallar": "Aktive Regeln",
    "Aktif ve pasif planlar.": "Aktive und passive Pläne.",
    "Aktiflik, e-posta, mağaza ve etiket bakiyesi kontrolü.": "Aktivitäts-, E-Mail-, Speicher- und Label-Balance-Kontrolle.",
    "alıcı": "Käufer",
    "Alıcı": "Käufer",
    "Alıcı adı": "Empfängername",
    "Alıcı ve adres": "Empfänger und Adresse",
    "Alt müşteri": "Unterkunde",
    "Alt müşteri hesaplarını, erişim durumlarını ve son giriş hareketlerini yönetin.": "Verwalten Sie Unterkundenkonten, Zugriffsstatus und aktuelle Anmeldeaktivitäten.",
    "Alt müşteriler": "Unterkunden",
    "Altı aydan eski, kullanılmamış ve stoktan düşürülmüş etiketler.": "Etiketten, die älter als sechs Monate sind, unbenutzt und aus dem Lagerbestand entfernt wurden.",
    "Amazon bağlantısını server link akışıyla başlatın; siparişler Shopify kaynak senkronundan alınır.": "Starten Sie die Amazon-Verbindung mit dem Server-Link-Flow; Bestellungen werden aus der Shopify-Quellsynchronisierung abgerufen.",
    "Amazon bağlantısını yönet": "Amazon-Link verwalten",
    "Amazon mağaza adı": "Name des Amazon-Shops",
    "Amazon mağazası bağla": "Verbinden Sie den Amazon-Shop",
    "Amazon onay linkini aç": "Öffnen Sie den Amazon-Bestätigungslink",
    "Amazon yetkilendirmeyi başlat": "Starten Sie die Amazon-Autorisierung",
    "Etsy bağlantısını server link akışıyla başlatın; siparişler Shopify kaynak senkronundan alınır.": "Starten Sie die Etsy-Verbindung mit dem Server-Link-Flow; Bestellungen werden aus der Shopify-Quellsynchronisierung abgerufen.",
    "Etsy mağaza adı": "Name des Etsy-Shops",
    "Etsy mağazası bağla": "Verbinden Sie den Etsy-Shop",
    "Etsy onay linkini aç": "Öffnen Sie den Etsy-Bestätigungslink",
    "Etsy yetkilendirmeyi başlat": "Starten Sie die Etsy-Autorisierung",
    "Sistem şu an meşgul. Başka bir Amazon/Etsy bağlantısı çalışıyor; birkaç dakika sonra tekrar deneyin.": "Das System ist ausgelastet. Eine andere Amazon/Etsy-Verbindung läuft; bitte versuchen Sie es in ein paar Minuten erneut.",
    "Ana mağaza": "Hauptgeschäft",
    "API anahtarı": "API-Schlüssel",
    "API kullanıcı": "API-Benutzer",
    "API şifre": "API-Passwort",
    "Ara servis": "Zwischendienst",
    "Arama ve durum filtresi aktif": "Such- und Statusfilter aktiv",
    "Atanmış etiket kaynakları.": "Zugewiesene Label-Ressourcen.",
    "Atanmamış": "Nicht zugewiesen",
    "ayrı listeyi aç": "separate Liste öffnen",
    "Ayrıştır": "analysieren",
    "Ayrım": "Kategorie",
    "Bağla": "Verbinden",
    "Bağlamak istediğiniz satış kanalını seçin.": "Wählen Sie den Vertriebskanal aus, den Sie anbinden möchten.",
    "Bağlantı": "Verbindung",
    "Bağlantı başlat": "Verbindung starten",
    "Bağlantı bilgileri": "Verbindungsinformationen",
    "Bağlantı bilgileri güvenli şekilde saklanır. Gizli alanlar gösterilmez; yeni değer girilirse güncellenir, boş bırakılırsa mevcut değer korunur.": "Verbindungsinformationen werden sicher gespeichert. Ausgeblendete Felder werden nicht angezeigt; Wenn ein neuer Wert eingegeben wird, wird dieser aktualisiert; Wenn es leer bleibt, bleibt der aktuelle Wert erhalten.",
    "Bağlantı durumu": "Verbindungsstatus",
    "Bağlantı modu (connector/ip)": "Verbindungsmodus (Connector/IP)",
    "Bağlantıyı kapat": "enge Verbindung",
    "Bağlantıyı tamamla": "Vervollständigen Sie die Verbindung",
    "Bağlantıyı test et": "Testen Sie die Verbindung",
    "Bağlı mağaza yok.": "Es gibt keine angeschlossenen Geschäfte.",
    "Bağlı mağazalar": "angeschlossene Geschäfte",
    "Bağlı satış kanalları ve entegrasyon özeti.": "Angeschlossene Vertriebskanäle und Integrationsübersicht.",
    "Bakım penceresinde tekrar çalışacak": "Im Wartungsfenster wird es wieder funktionieren",
    "Bakım penceresinde yeniden import": "Im Wartungsfenster erneut importieren",
    "Başarı oranı": "Erfolgsquote",
    "Başarılı": "Erfolgreich",
    "Başlamadı": "Nicht gestartet",
    "Başlangıç": "Anfang",
    "Başlangıç durumu yükleniyor": "Ausgangszustand wird geladen",
    "Başlangıç şifresi": "Anfangspasswort",
    "Baz fiyat": "Grundpreis",
    "Baz fiyat:": "Grundpreis:",
    "Bekleyen ödeme": "ausstehende Zahlung",
    "Bilinmiyor": "Unbekannt",
    "Billbee adı": "Billbee-Name",
    "Birden fazla ürün/hizmet satırını tek faturada toplayıp PDF üretin.": "Sammeln Sie mehrere Produkt-/Dienstleistungszeilen in einer einzigen Rechnung und erstellen Sie PDF.",
    "Birim brüt": "Einheit brutto",
    "Birim fiyat": "Stückpreis",
    "Birim net": "Einheit netto",
    "Brüt toplam": "Bruttosumme",
    "Bu manuel Shopify faturası iptal edilecek. Devam edilsin mi?": "Diese manuelle Shopify-Rechnung wird storniert. Fortfahren?",
    "Bitiş": "Beenden",
    "Bize ulaşın": "Kontakt",
    "Bonus işaretlenen satırlar 0 EUR tutulur ve otomatik fiyat tamiri bu kayıtları ücretlendirmez.": "Mit Bonus markierte Zeilen bleiben bei 0 EUR und die automatische Preisreparatur belastet diese Datensätze nicht.",
    "Bonus/telafi etiketi": "Bonus-/Vergütungs-Label",
    "Brüt": "Brutto",
    "Girilen tutar nettir; KDV seçilen orana göre üzerine eklenir.": "Der eingegebene Betrag ist netto; die MwSt. wird gemäß dem ausgewählten Satz hinzugerechnet.",
    "KDV": "MwSt.",
    "Manuel Shopify faturası iptal edilemedi.": "Die manuelle Shopify-Rechnung konnte nicht storniert werden.",
    "Net toplam": "Nettosumme",
    "Bu değerler mevcut fatura PDF ve admin manuel fatura akışlarında kullanılır.": "Diese Werte werden in vorhandenen Rechnungs-PDF- und Administrator-Handbuch-Rechnungsflüssen verwendet.",
    "Bu etiket status bakmadan admin stok havuzuna alınacak. Etiket artık kullanıcılar tarafından satın alınabilir olacak. Devam edilsin mi?": "Dieses Label wird ohne Statusprüfung zurück in den Admin-Bestand gelegt. Nutzer können es danach wieder kaufen. Fortfahren?",
    "Bu filtrelerle eşleşen müşteri bulunamadı.": "Es wurden keine Kunden gefunden, die diesen Filtern entsprechen.",
    "Bu filtrede etiket yok.": "Keine Labels in diesem Filter.",
    "Bu linkle kayıt olan müşteriler otomatik olarak hesabınıza bağlanır.": "Kunden, die sich über diesen Link registrieren, werden automatisch mit Ihrem Konto verbunden.",
    "Bu sayfa bakiye": "Diese Seitenbilanz",
    "Bu sayfa gönderi": "Diese Seitensendung",
    "Bu sayfa mağaza": "Diese Seite speichern",
    "Bu sipariş Packstation/Postfiliale adresli. Etiket oluşturmak için normal teslimat adresi girin.": "Diese Bestellung hat eine Packstation-/Postfiliale-Adresse. Geben Sie eine normale Lieferadresse ein, um ein Label zu erstellen.",
    "Bu sipariş Packstation/Postfiliale adresli. Toplu işlemde seçilmez; tekli etiket oluşturabilirsiniz. Packstation için Postnummer bilgisi adres içinde olmalı.": "Diese Bestellung hat eine Packstation-/Postfiliale-Adresse. Sie ist in Sammelaktionen nicht auswählbar; ein Einzellabel kann erstellt werden. Bei Packstation muss die Postnummer in der Adresse stehen.",
    "Bu sipariş için gönderi yok.": "Für diese Bestellung gibt es keinen Versand.",
    "Bu siparişe bağlı gönderiler": "Sendungen im Zusammenhang mit dieser Bestellung",
    "Bugün": "Heute",
    "Bugün Berlin saatiyle 18:00-23:59 arasında sistem kapalı olacaktır. Geçişten sonra yeni sistemimiz ve son özelliklerimizle tekrar karşınızda olacağız.": "Das System wird heute zwischen 18:00 und 23:59 Uhr Berliner Zeit geschlossen. Nach der Umstellung sind wir mit unserem neuen System und den neuesten Funktionen zurück.",
    "Bugünkü gönderi ritmini ve hesabın dikkat isteyebileceği alanlarını hızlıca okuyun.": "Lesen Sie kurz den heutigen Veröffentlichungsrhythmus und die Bereiche des Kontos, die möglicherweise Ihrer Aufmerksamkeit bedürfen.",
    "Cache boyutu": "Cachegröße",
    "Checkout'u aç": "Checkout öffnen",
    "Cloudflare D1 içinde müşteri hesabı oluşturur.": "Erstellt ein Kundenkonto in Cloudflare D1.",
    "Cloudflare sürüm ve audit özeti.": "Cloudflare-Version und Audit-Zusammenfassung.",
    "Cloudflare taşıma sürüm ve audit durumu.": "Cloudflare-Migrationsversion und Prüfstatus.",
    "Cloudflare uygulaması": "Cloudflare-App",
    "CSV export": "CSV-Export",
    "CSV, TSV veya XLSX dosyasındaki adresleri manuel etikete çevirin.": "Konvertieren Sie Adressen aus CSV-, TSV- oder XLSX-Dateien in manuelle Etiketten.",
    "Carrier durum": "Carrier-Status",
    "Packstation/Postfiliale adresleri bu internal DHL etiket akışında desteklenmiyor.": "Packstation-/Postfiliale-Adressen werden in diesem internen DHL-Label-Ablauf nicht unterstützt.",
    "Packstation/Postfiliale adresleri bu işlemde toplu veya manuel oluşturulamaz. Lütfen sipariş satırındaki tekli etiket oluşturmayı kullanın.": "Packstation-/Postfiliale-Adressen können in diesem Sammel- oder manuellen Ablauf nicht erstellt werden. Bitte nutzen Sie die Einzellabel-Erstellung in der Bestellzeile.",
    "Packstation/Postfiliale adresleri toplu etiket işleminde seçilemez. Tekli etiket oluşturmayı kullanın.": "Packstation-/Postfiliale-Adressen können in der Sammellabel-Erstellung nicht ausgewählt werden. Bitte Einzellabel-Erstellung verwenden.",
    "Packstation/Postfiliale adresli siparişler toplu etiket işlemine seçilemez; normal teslimat adresiyle tekli işlem yapılmalı.": "Bestellungen mit Packstation-/Postfiliale-Adresse können nicht für Sammellabels ausgewählt werden; nutzen Sie den Einzellabel-Ablauf mit einer normalen Lieferadresse.",
    "Packstation/Postfiliale adresli siparişler toplu etiket işlemine seçilemez; tekli etiket oluşturmayı kullanın.": "Bestellungen mit Packstation-/Postfiliale-Adresse können nicht für Sammellabels ausgewählt werden; bitte die Einzellabel-Erstellung verwenden.",
    "Bu gönderi zaten iptal edilmiş veya kapalı.": "Diese Sendung ist bereits storniert oder geschlossen.",
    "Bu gönderi iptal edilemez: DHL/taşıyıcı hareketi görünüyor. Etiket krediye iade edilmedi.": "Diese Sendung kann nicht storniert werden: DHL-/Carrier-Bewegung ist sichtbar. Das Label wurde nicht dem Guthaben gutgeschrieben.",
    "Bu gönderi iptal edilemez: taşıyıcı durumu güvenli şekilde Status offen / hareket yok olarak doğrulanamadı.": "Diese Sendung kann nicht storniert werden: Der Carrier-Status konnte nicht sicher als Status offen / keine Bewegung bestätigt werden.",
    "Etiket iptal edildi; kredi bakiyenize geri döndü ve sipariş tekrar etiket bekliyor.": "Das Label wurde storniert; das Guthaben ist zurückgebucht und die Bestellung wartet wieder auf ein Label.",
    "Etiket/gönderi iptal edilsin mi?": "Label/Sendung stornieren?",
    "Etiket kredisi stoğa geri döner ve sipariş tekrar etiket bekleyen duruma alınır.": "Das Label-Guthaben wird zurückgebucht und die Bestellung wartet wieder auf ein Label.",
    "Gönderi iptal edilsin mi?": "Sendung stornieren?",
    "Gönderi iptal edildi; etiket kredisi hesabınıza geri döndü ve sipariş tekrar etiket bekliyor.": "Sendung storniert; das Label-Guthaben ist zurückgebucht und die Bestellung wartet wieder auf ein Label.",
    "Gönderi kaydı bulunamadı.": "Sendungsdatensatz nicht gefunden.",
    "Gönderiyi iptal et": "Sendung stornieren",
    "İptal başarılı olursa etiket kredisi müşteri bakiyesine geri döner ve sipariş tekrar etiket bekleyen duruma gelir.": "Bei erfolgreicher Stornierung wird das Label-Guthaben dem Kundenkonto gutgeschrieben und die Bestellung wartet wieder auf ein Label.",
    "Sadece DHL hareketi olmayan / Status offen etiketler iptal edilebilir.": "Nur Labels ohne DHL-Bewegung / Status offen können storniert werden.",
    "Seçili gönderiler iptal edilsin mi?": "Ausgewählte Sendungen stornieren?",
    "Teknik hata kayıtları müşteri iptaliyle krediye alınamaz.": "Technische Fehlerdatensätze können nicht per Kundenstorno gutgeschrieben werden.",
    "Çıkış": "Abmelden",
    "D1 snapshot": "D1-Schnappschuss",
    "Değer": "Wert",
    "Değişim": "Ändern",
    "Destek": "Support",
    "Detay": "Details",
    "Destek merkezi": "Support-Center",
    "Destek raporu yükleniyor": "Supportbericht wird geladen",
    "Destek talebi": "Supportanfrage",
    "Destek talebi yok.": "Keine Supportanfragen.",
    "Destek talepleri admin rapor ekranına referans numarasıyla düşer.": "Supportanfragen werden auf dem Administratorberichtsbildschirm mit einer Referenznummer angezeigt.",
    "Desteklenen pazar yerleri": "Unterstützte Marktplätze",
    "Devre dışı": "deaktiviert",
    "DHL hata": "Sogar DHL",
    "DHL hata oranı": "DHL-Fehlerquote",
    "DHL kontrol": "DHL kontrol",
    "DHL kontrol özeti": "Zusammenfassung des DHL-Schecks",
    "DHL kontrol performansı": "DHL-Kontrollleistung",
    "DHL taşıyıcı kontrol sonuçları ve hatalı/şüpheli etiket sinyalleri.": "Prüfergebnisse des DHL-Spediteurs und fehlerhafte/verdächtige Etikettensignale.",
    "DHL event timeline": "DHL-Ereignisverlauf",
    "DHL takip sayfasını yeni sekmede aç": "DHL-Sendungsverfolgung in neuem Tab öffnen",
    "DHL/taşıyıcı kontrol kuyrukları ve sonuç özetleri.": "DHL/Spediteur-Prüfwarteschlangen und Ergebniszusammenfassungen.",
    "Dış servis ihtiyacı": "Auswärtiger Dienstbedarf",
    "Dış kullanım": "Externe Nutzung",
    "Dışa aktarım": "Export",
    "Diğer": "Andere",
    "Durum": "Status",
    "Doğrulama bekleyen": "Ausstehende Überprüfung",
    "Doğrulanmış": "verifiziert",
    "dosya işlendi": "Datei verarbeitet",
    "Dosya seç": "Datei auswählen",
    "Durumu yenile": "Status aktualisieren",
    "Düzenle": "Bearbeiten",
    "E-Mail prüfen": "E-Mail prüfen",
    "E-posta 2FA": "E-Mail 2FA",
    "E-posta adresi": "E-Mail-Adresse",
    "E-posta doğrulama": "E-Mail-Bestätigung",
    "E-posta ile ikinci doğrulama.": "Zweite Verifizierung per E-Mail.",
    "eBay bağla": "mit eBay verbinden",
    "eBay bağlantıları": "eBay-Links",
    "eBay bağlantısı yok.": "Es gibt keinen Link zu eBay.",
    "eBay hesabınızı güvenli bağlantı akışıyla ekleyin.": "Fügen Sie Ihr eBay-Konto über einen sicheren Verbindungsablauf hinzu.",
    "eBay mağazası bağla": "eBay-Shop anschließen",
    "eBay OAuth": "eBay OAuth",
    "eBay OAuth başlat": "Starten Sie eBay OAuth",
    "eBay ortamı": "eBay-Umgebung",
    "eBay yeniden bağla": "eBay-Verbindung wiederherstellen",
    "Eğitim videoları": "Schulungsvideos",
    "Eğitimler": "Schulungen",
    "Eğitimler yükleniyor": "Schulungen werden geladen",
    "Ekibiniz için sınırlı müşteri hesabı oluşturun.": "Erstellen Sie begrenzte Kundenkonten für Ihr Team.",
    "Ekip üyeleri": "Teammitglieder",
    "Ekip üyeleri yükleniyor": "Teammitglieder werden geladen",
    "Ekip üyesi yok.": "Es gibt keine Teammitglieder.",
    "Ekip yönetimi": "Teamverwaltung",
    "Eksik/hatalı etiketler": "Fehlende/falsche Etiketten",
    "empfänger": "empfänger",
    "Eski sistemdeki temel store ayarları ve platform credential bilgileri.": "Grundlegende Store-Einstellungen und Plattform-Anmeldeinformationen im alten System.",
    "Eski veya yanlış faturaların toplu otomatik düzeltilmesi ayrıca ele alınacak.": "Die automatische Massenkorrektur alter oder falscher Rechnungen wird separat behandelt.",
    "Etiket / indirme": "Markieren / herunterladen",
    "Etiket bakiyeleri": "Label-Guthaben",
    "Etiket bakiyesi": "Beschriften Sie den Kontostand",
    "Etiket bakiyesi ve faturalar": "Beschriften Sie Salden und Rechnungen",
    "Etiket bakiyesi yok.": "Es gibt kein Label-Gleichgewicht.",
    "Etiket bilgileri yükleniyor": "Etiketteninformationen werden geladen",
    "Etiket çıktısı": "Etikettenausdruck",
    "Etiket durumu": "Etikettenstatus",
    "Etiket Envanteri": "Label-Bestand",
    "Etiket envanteri": "Label-Bestand",
    "Etiket envanteri ve faturalama": "Beschriften Sie den Bestand und die Rechnungsstellung",
    "Hatalı Etiketler": "Fehlerhafte Labels",
    "Hatalı etiket detayı": "Details zum fehlerhaften Label",
    "Hatalı etiket yok.": "Keine fehlerhaften Labels.",
    "Hatalı etiketler alınamadı.": "Fehlerhafte Labels konnten nicht geladen werden.",
    "Hatalı etiketler yükleniyor": "Fehlerhafte Labels werden geladen",
    "Müşteri İptalleri": "Kundenstornierungen",
    "Taşıyıcı Kontrol Hataları": "Carrier-Prüffehler",
    "Etiket kaynağı yükle": "Label-Quelle hochladen",
    "Etiket Kontrolleri": "Label-Prüfungen",
    "Etiket kontrolleri": "Label-Steuerelemente",
    "Etiket kredi sepeti": "Beschriften Sie den Warenkorb",
    "Etiket kredilerini checkout ile satın alın ve ödeme sonrası bakiyeye işleyin.": "Kaufen Sie Label-Gutschriften beim Bezahlvorgang und verrechnen Sie sie nach der Zahlung mit dem Restbetrag.",
    "Etiket oluştur": "Label erstellen",
    "Etiket oluşturma": "Erstellen Sie ein Etikett",
    "Etiket oluştu": "Label erstellt",
    "Etiket paketleri": "Aufkleberpakete",
    "Etiket sağlayıcı": "Etikettenanbieter",
    "Etiket satın al": "Labels kaufen",
    "Etiket Satın Al": "Etikett kaufen",
    "Etiket satın alma": "Etiketten kaufen",
    "Etiket satın alma faturaları": "Kaufrechnungen kennzeichnen",
    "Etiket satın almaları": "Käufe kennzeichnen",
    "Etiket Ürünleri": "Label-Produkte",
    "Etiket ürünleri için müşteri bazlı fiyat tanımları.": "Kundenbasierte Preisdefinitionen für Etikettenprodukte.",
    "Etiket ürünleri yükleniyor": "Beschriften Sie die Produkte, die geladen werden",
    "Etiket ürünleri, stok hareketleri ve taşıyıcı kontrolleri.": "Kennzeichnen Sie Produkte, Lagerbewegungen und Spediteurkontrollen.",
    "Etiket ürünü": "Produkt kennzeichnen",
    "Etiket ürünü yok": "Kein Labelprodukt",
    "Etiket ürünü yükleniyor": "Beschriften Sie das Laden des Produkts",
    "Etiket verileri yükleniyor": "Label-Daten werden geladen",
    "Etikete dönüştürülmeye hazır": "Bereit zur Umwandlung in Etiketten",
    "Etiketi oluştur": "Erstellen Sie das Label",
    "Etiketler": "Labels",
    "Etiketlere dön": "Zurück zu den Labels",
    "Etikette SKU": "Beschriften Sie die SKU",
    "Etiket kullanıma açılamadı.": "Label konnte nicht zur Nutzung freigegeben werden.",
    "etiketürünü": "Etikettprodukt",
    "export dosyasına yazıldı": "in die Exportdatei geschrieben",
    "Fatura / ödeme": "Rechnung/Zahlung",
    "Fatura adresi": "Rechnungsadresse",
    "Fatura adresi farklı": "Rechnungsadresse abweichend",
    "Fatura adresi yedeği": "Rechnungsadresse als Fallback",
    "Fatura ayarları": "Rechnungseinstellungen",
    "Fatura bilgileri": "Abrechnungsdaten",
    "Fatura durumu": "Rechnungsstatus",
    "Fatura posta kodu": "Postleitzahl der Rechnungsstellung",
    "Fatura satırı yok.": "Es gibt keine Rechnungszeile.",
    "Fatura şehir": "Bill City",
    "Fatura toplamı": "Rechnungssumme",
    "Fatura ülke": "Rechnungsland",
    "Fatura ve etiket satın alma kayıtları.": "Kaufunterlagen auf Rechnung stellen und etikettieren.",
    "Fatura ve gönderici adresi": "Rechnungs- und Versenderadresse",
    "Fatura ve gönderici bilgileri": "Rechnungs- und Absenderinformationen",
    "Fatura yok.": "Es liegt keine Rechnung vor.",
    "Faturalama": "Abrechnung",
    "Faturalama verisi yükleniyor": "Abrechnungsdaten werden geladen",
    "Faturalar": "Rechnungen",
    "Faturalar, PDF üretimi ve etiket satın alma faturaları.": "Rechnungen, PDF-Produktion und Etikettenkaufrechnungen.",
    "Faturalara dön": "Zurück zu Rechnungen",
    "Final eşitleme": "endgültiger Ausgleich",
    "Final senkron": "Endgültig synchron",
    "Fiyat matrisi": "Preismatrix",
    "Fiyatları aç": "Offene Preise",
    "Gadget kapatma": "Herunterfahren des Gadgets",
    "Gadget tarafındaki server link senaryosuyla aynı başlat/onayla akışını kullanır.": "Es verwendet denselben Initialisierungs-/Bestätigungsablauf wie das Server-Link-Szenario auf der Gadget-Seite.",
    "Geçiş planı": "Übergangsplan",
    "Genel Bakış": "Übersicht",
    "Genel not": "Genel nicht",
    "Gizli anahtar": "Secret Key",
    "Gönder": "Schicken",
    "Gönderen adı": "Absendername",
    "Gönderi": "Post",
    "Gönderi başarı oranı": "Sendungserfolgsquote",
    "Gönderi bilgileri": "Versandinformationen",
    "Gönderi bilgisi": "Versandinformationen",
    "Gönderi bulunamadı": "Sendung nicht gefunden",
    "Gönderi detayı açılamadı": "Sendungsdetails konnten nicht geöffnet werden",
    "Gönderi detayı yükleniyor": "Sendungsdetails werden geladen",
    "Gönderi tipi": "Sendungstyp",
    "Gönderi yok.": "Keine Sendungen.",
    "Gönderici adı": "Absendername",
    "Gönderici adresi": "Absenderadresse",
    "Gönderici posta kodu": "Postleitzahl des Absenders",
    "Gönderici şehir": "Absenderstadt",
    "Gönderici ülke": "Sendeland",
    "Gönderiler": "Sendungen",
    "Gönderiler yükleniyor": "Sendungen werden geladen",
    "Gönderilere dön": "Zurück zu den Sendungen",
    "Gönderim": "Überweisen",
    "gönderitipi": "Posttyp",
    "Görünen DHL etiketlerini kontrol et": "Achten Sie auf sichtbare DHL-Etiketten",
    "Gün": "Label",
    "Güncelleme": "Aktualisieren",
    "Günlük destek raporu yok.": "Es gibt keine täglichen Supportberichte.",
    "Günlük teknik talep raporu": "Täglicher technischer Bedarfsbericht",
    "Güvenlik": "Sicherheit",
    "Hareketli / kullanılmış": "Umzug/gebraucht",
    "Harici sipariş": "äußere Ordnung",
    "Hata kayıtları": "Fehlerprotokolle",
    "Hata kayıtları ve arka plan işlem izleri.": "Fehlerprotokolle und Hintergrundprozessspuren.",
    "Hatalı": "Falsch",
    "Hazır": "Bereit",
    "Hazır etiketler": "Fertige Etiketten",
    "Hazır stok:": "Fertigbestand:",
    "Hazırlık durumu": "Bereitschaftsstatus",
    "Henüz affiliate profiliniz yok.": "Sie haben noch kein Affiliate-Profil.",
    "Henüz ekip üyesi yok.": "Es gibt noch keine Teammitglieder.",
    "Henüz hazır değil": "noch nicht fertig",
    "Henüz mağaza yok.": "Es gibt noch keine Geschäfte.",
    "Henüz referans kaydı yok.": "Es liegen noch keine Referenzdatensätze vor.",
    "Henüz sipariş yok.": "Noch keine Bestellungen.",
    "Her şey yolunda": "Alles läuft stabil",
    "Hesaba geç": "Zum Konto wechseln",
    "Hesap": "Konto",
    "Hesap aktif": "Konto aktiv",
    "Hesap aktif.": "Konto ist aktiv.",
    "Hesap bilgileri": "Kontoinformationen",
    "Hesap güvenliği": "Kontosicherheit",
    "Hesap hazır": "Konto ist fertig",
    "Hesap hazırlığı": "Kontovorbereitung",
    "Hesap şifrenizi güvenli şekilde güncelleyin.": "Aktualisieren Sie Ihr Kontopasswort sicher.",
    "Hızlı yönetim": "Schnelle Verwaltung",
    "Hareket yok": "Keine Bewegung",
    "Importu oluştur": "Import erstellen",
    "İade": "Zurückkehren",
    "İade sinyali": "Rücksignal",
    "İç platformlar": "Innenplattformen",
    "İç servis": "interner Dienst",
    "İptal": "Stornieren",
    "İptal edilen etiketler": "Abgebrochene Labels",
    "İptal kayıtları": "Stornierungsunterlagen",
    "İstemci anahtarı": "Kundenschlüssel",
    "İstemci gizli anahtarı": "Client Secret",
    "İstemci ID": "Client-ID",
    "İstenen": "gewünscht",
    "İşlem": "Aktion",
    "JTL DB adı": "JTL-DB-Name",
    "JTL DB kullanıcı": "JTLDB-Benutzer",
    "JTL DB port": "JTL-DB-Port",
    "JTL DB sunucu": "JTL-DB-Server",
    "JTL DB şifre": "JTL-DB-Passwort",
    "JTL siparişinde ağırlık bilgisi gelmedi. Yanlış ürün seçilmemesi için etiket ürününü manuel seçin.": "Für diese JTL-Bestellung wurde kein Gewicht übertragen. Wählen Sie das Labelprodukt manuell, damit kein falsches Produkt verwendet wird.",
    "JTL URL": "JTL-URL",
    "Katıldığınızda size özel referans kodu ve kayıt linki oluşur.": "Bei Ihrer Anmeldung erhalten Sie einen speziellen Referenzcode und einen Registrierungslink.",
    "Kaydet ve PDF üret": "PDF speichern und generieren",
    "Kaydedilmiş DHL event yok.": "Keine gespeicherten DHL-Ereignisse.",
    "Kayıt": "Aufzeichnen",
    "Kayıt bulunamadı.": "Kein Datensatz gefunden.",
    "Kayıt linki": "Registrierungslink",
    "Kapat": "Schließen",
    "Kayıt yok.": "Keine Aufzeichnung.",
    "Kayıtlı": "Eingetragen",
    "Kaynak platform senkronu": "Synchronisierung der Quellplattform",
    "Kaynak platforma takip gönder": "Senden Sie „Folgen“ an die Quellplattform",
    "Kaynak senkron": "Quelle synchron",
    "Kargo adresi": "Lieferadresse",
    "Kargo adresinden farklı": "Abweichend von der Lieferadresse",
    "Kalan": "Übrig",
    "KDV %19": "MwSt. 19 %",
    "KDV, numara formatı ve kredi faturası kuralları.": "Regeln für Mehrwertsteuer, Zahlenformat und Gutschriftsrechnung.",
    "Kenpost ana sayfa": "Kenpost Startseite",
    "Kenpost fatura numaraları, KDV oranı ve kredi faturası kuralları.": "Kenpost-Rechnungsnummern, Mehrwertsteuersatz und Gutschriftsrechnungsregeln.",
    "Kenpost operasyon verisi": "Kenpost-Betriebsdaten",
    "Kenpost yeni panel": "Kenpost neues Panel",
    "Kimlik bilgisi": "Anmeldeinformationen",
    "Komisyon hareketi yok.": "Es gibt keine Provisionsbewegung.",
    "Komisyon hareketleri": "Provisionsgeschäfte",
    "Komisyon ve bonus": "Provisionen & Boni",
    "Kontrol çalışmaları": "Kontrollstudien",
    "Kontrol edilen": "kontrolliert",
    "Kontrol geçmişi": "Prüfverlauf",
    "Kontrol mesajı": "Prüfmeldung",
    "Kontrol paneli": "Dashboard",
    "Kontrol paneli açılamadı": "Das Bedienfeld konnte nicht geöffnet werden",
    "Konu ve mesajı yazın; ekip bu referansla takip eder.": "Geben Sie den Betreff und die Nachricht ein. Das Team folgt mit diesem Hinweis.",
    "Kredi Durumu": "Kreditstatus",
    "Kredi faturası": "Gutschriftsrechnung",
    "Kredileri işle ve faturala": "Kredite bearbeiten und abrechnen",
    "Kullanıcı": "Benutzer",
    "Kullanıcı adı": "Benutzername",
    "Kullanıcı eğitim ve Almanca etiket indirme içerikleri.": "Benutzerschulung und Download-Inhalte für deutsche Labels.",
    "Kullanıcı video eğitimleri ve Almanca etiket indirme anlatımları.": "Benutzervideo-Tutorials und Anweisungen zum Herunterladen von Etiketten auf Deutsch.",
    "Kullanılabilir etiket": "Verfügbares Etikett",
    "Kullanılabilir etiketler": "Verfügbare Labels",
    "Kullanılan kod": "Code verwendet",
    "kullanıma açıldı.": "zur Nutzung freigegeben.",
    "Kullanım": "Verwenden",
    "Label hatası": "Etikettenfehler",
    "Linki kopyala": "Link kopieren",
    "Listelenen": "Gelisted",
    "Mağaza": "Speichern",
    "Mağaza adı": "Shopname",
    "Mağaza aktif": "Shop aktiv",
    "Mağaza ayarları": "Einstellungen speichern",
    "Mağaza bağlantıları": "Store-Links",
    "Mağaza bağlantısı": "Store-Link",
    "Mağaza hareketlerini, etiket hazır durumunu ve gönderi temposunu tek yerden takip edin.": "Verfolgen Sie Filialbewegungen, den Status der Etikettenbereitschaft und die Versandgeschwindigkeit an einem Ort.",
    "Mağaza oluştur": "Shop erstellen",
    "Mağaza URL": "Shop-URL",
    "Mağaza yükleniyor": "Laden laden",
    "Mağazalar": "Shops",
    "Mağazalar yükleniyor": "Die Läden laden",
    "Henüz aktif mağaza yok.": "Noch keine aktiven Shops vorhanden.",
    "Pasif mağazalar": "Inaktive Shops",
    "Pasif mağazalar ana listeden ayrılır; geçmiş ve yeniden aktifleştirme erişimi korunur.": "Inaktive Shops werden von der Hauptliste getrennt; Verlauf und Reaktivierung bleiben erhalten.",
    "Pasif mağazaları gizle": "Inaktive Shops ausblenden",
    "Pasif mağazaları göster": "Inaktive Shops anzeigen",
    "Mağazalara dön": "Zurück zu den Geschäften",
    "Mağazalara git": "Gehen Sie in Geschäfte",
    "Mağazalarım": "Meine Geschäfte",
    "mağazasında fulfillment/tracking kaydını yeniden dener.": "Versucht den Erfüllungs-/Tracking-Datensatz in seinem Shop erneut.",
    "MAK{yıl}-{satın alma id}": "MAK{Jahr}-{Kauf-ID}",
    "Manuel fatura oluştur": "Erstellen Sie eine manuelle Rechnung",
    "Max gram": "Maximales Gramm",
    "Max Mustermann Musterstr. 12 10115 Berlin": "Max Mustermann Musterstr. 12 10115 Berlin",
    "Menüyü aç": "Menü öffnen",
    "Menüyü kapat": "Menü schließen",
    "Mevcut snapshot import edildi": "Aktueller Snapshot importiert",
    "Mevcut şifre": "Aktuelles Passwort",
    "Min gram": "Mein Gramm",
    "Müşteri": "Kunde",
    "Müşteriye bağlı": "Kundenbezogen",
    "Müşteri bulunamadı": "Kunde nicht gefunden",
    "Müşteri detayı açılamadı": "Kundendaten konnten nicht geöffnet werden",
    "Müşteri detayı yükleniyor": "Kundendaten werden geladen",
    "Müşteri etiket bakiyeleri.": "Kunden-Label-Salden.",
    "Müşteri fiyatları": "Kundenpreise",
    "Müşteri hesabını oluşturmak için temel bilgileri girin.": "Geben Sie grundlegende Informationen ein, um das Kundenkonto zu erstellen.",
    "Müşteri hesapları hazırlanıyor": "Kundenkonten sind in Vorbereitung",
    "Müşteri hesaplarını, mağaza bağlantılarını, etiket bakiyelerini ve destek geçişlerini tek ekrandan yönetin.": "Verwalten Sie Kundenkonten, Shop-Links, markieren Sie Guthaben und Support-Pässe auf einem einzigen Bildschirm.",
    "Müşteri Kontrol Merkezi": "Kundenkontrollzentrum",
    "Müşteri olarak gör": "Als Kunde ansehen",
    "Müşteri oluştur": "Kunde anlegen",
    "Müşteri paneli": "Kundenbereich",
    "Müşteri plan kayıtları ve abonelik segmentleri.": "Anmeldungen für Kundenpläne und Abonnementsegmente.",
    "Müşteri seç": "Kunden auswählen",
    "Müşteri teknik destek talepleri, günlük rapor ve öncelikli kayıtlar.": "Technische Supportanfragen von Kunden, tägliche Berichte und Prioritätsaufzeichnungen.",
    "Müşteri teknik talepleri ve günlük rapor.": "Technische Kundenanfragen und täglicher Bericht.",
    "Müşteri ve alt müşteri yönetimi": "Kunden- und Unterkundenverwaltung",
    "Müşteri ve sistem hata referansları.": "Referenzen zu Kunden- und Systemfehlern.",
    "Müşteri, şirket veya e-posta ara": "Suchen Sie nach Kunde, Firma oder E-Mail",
    "Müşteriler": "Kunden",
    "Müşterilere dön": "Zurück zu den Kunden",
    "Müşteriye atanabilecek yeni plan tanımı oluşturun.": "Erstellen Sie eine neue Plandefinition, die dem Kunden zugewiesen werden kann.",
    "myshopify.com domaini": "myshopify.com-Domains",
    "Object key:": "Objektschlüssel:",
    "olarak müşteri panelindesiniz.": "Sie befinden sich im Kundenpanel.",
    "Oluştur": "Erstellen",
    "Oluşturulan gönderi ve etiket kayıtları; arama, sayfalama ve arka plan takip senkronu ile hızlı yönetim.": "Post- und Label-Datensätze erstellt; Schnelle Verwaltung mit Such-, Paging- und Hintergrundüberwachungssynchronisierung.",
    "Oluşturuldu": "Erstellt",
    "Oluşturulma": "Schaffung",
    "Onboarding açılamadı": "Onboarding konnte nicht geöffnet werden",
    "Online seller prefix": "Online-Verkäufer-Präfix",
    "Operasyon Nabzı": "Betriebsimpuls",
    "Operasyon notu": "Betriebshinweis",
    "Açık olduğunda sistem bu mağazadan siparişleri arka planda düzenli çeker.": "Wenn aktiviert, ruft das System Bestellungen aus diesem Shop regelmäßig im Hintergrund ab.",
    "Arama": "Suche",
    "Atlandı": "Übersprungen",
    "Çalışıyor": "Läuft",
    "Filtrele": "Filtern",
    "Günde bir": "Einmal täglich",
    "Hata sayısı": "Fehleranzahl",
    "Hatalar": "Fehler",
    "Kontrol raporu": "Prüfbericht",
    "Kontrol raporu alınamadı.": "Der Prüfbericht konnte nicht geladen werden.",
    "Kontrol raporu yükleniyor": "Prüfbericht wird geladen",
    "Kontrol sıklığı": "Prüffrequenz",
    "Mağaza kontrol raporu": "Shop-Prüfbericht",
    "Mağaza otomatik kontrol durumu": "Status der automatischen Shop-Prüfung",
    "Mağaza, müşteri veya e-posta": "Shop, Kunde oder E-Mail",
    "Otomatik kontrol": "Automatische Prüfung",
    "Otomatik sipariş alma": "Automatischer Bestellimport",
    "Otomatik sipariş alma denemeleri, hatalar ve sıradaki kontroller.": "Automatische Bestellimport-Versuche, Fehler und kommende Prüfungen.",
    "Otomatik sipariş alma hataları ve sıradaki kontroller.": "Fehler beim automatischen Bestellimport und kommende Prüfungen.",
    "Otomatik sipariş kontrolü": "Automatische Bestellprüfung",
    "Sıradaki kontrol": "Nächste Prüfung",
    "Son başarılı": "Letzter Erfolg",
    "Son kontrol denemeleri": "Letzte Prüfversuche",
    "Son deneme": "Letzter Versuch",
    "Son hata": "Letzter Fehler",
    "Şimdi kontrol et": "Jetzt prüfen",
    "Tüm durumlar": "Alle Status",
    "5 dakikada bir": "Alle 5 Minuten",
    "10 dakikada bir": "Alle 10 Minuten",
    "15 dakikada bir": "Alle 15 Minuten",
    "30 dakikada bir": "Alle 30 Minuten",
    "Saatte bir": "Stündlich",
    "3 saatte bir": "Alle 3 Stunden",
    "6 saatte bir": "Alle 6 Stunden",
    "12 saatte bir": "Alle 12 Stunden",
    "Operasyon, hata ve entegrasyon ayarları.": "Betriebs-, Fehler- und Integrationseinstellungen.",
    "Opsiyonel URL": "Optionale URL",
    "Ortam durumu": "Umgebungsstatus",
    "OTTO adı": "OTTO-Name",
    "Ödeme entegrasyonu eksik:": "Zahlungsintegration fehlt:",
    "Ödemeyi doğrula": "Zahlung überprüfen",
    "Ödendi": "Bezahlt",
    "Ödenen": "Bezahlt",
    "Önbellek sipariş": "Cache-Reihenfolge",
    "Önceki": "Ehemalig",
    "Öncelik": "Priorität",
    "Öncelikli": "Priorität",
    "Paket adedi": "Anzahl der Pakete",
    "Panel bilgileri yüklenmeye hazır": "Die Panel-Informationen können geladen werden",
    "parça": "Stück",
    "PayPal, Klarna, banka havalesi, SEPA ve eğitim dokümanları ödeme sağlayıcı kararından sonra bağlanacak.": "PayPal, Klarna, Banküberweisung, SEPA und Bildungsdokumente werden nach der Entscheidung des Zahlungsanbieters angebunden.",
    "Pazar yeri bağlantılarınızı, sipariş senkronunu ve mağaza ayarlarını tek yerden yönetin.": "Verwalten Sie Ihre Marktplatzverbindungen, Auftragssynchronisierung und Shop-Einstellungen an einem Ort.",
    "Pazar yeri takip yazımı, label üretimi ve iade/iptal sinyalleri.": "Marktplatz-Tracking-Schreiben, Etikettenproduktion und Rückgabe-/Stornierungssignale.",
    "Pazar yerine takip yazımı başarılı olan gönderiler baz alınır.": "Als Grundlage dienen Sendungen, die in der Nachbereitung an den Marktplatz erfolgreich sind.",
    "PDF aç": "PDF öffnen",
    "PDF olan": "Mit PDF",
    "PDF ZIP": "PDF-ZIP",
    "PDF boyutu": "PDF-Größe",
    "PDF etiket kaynaklarını D1/R2 akışına aktarır.": "Exportiert PDF-Label-Ressourcen in den D1/R2-Stream.",
    "PDF tarihi": "PDF-Geschichte",
    "PDF yükleme": "PDF hochladen",
    "Performans risk göstergeleri": "Leistungsrisikoindikatoren",
    "Plan adı": "Planname",
    "Plan listesi": "Planliste",
    "Plan ve etiket satın alma durumu.": "Kaufstatus planen und kennzeichnen.",
    "Platform bağlantı bilgilerinizi güvenli şekilde ekleyin.": "Fügen Sie Ihre Plattformverbindungsinformationen sicher hinzu.",
    "Platform bağlantı ve senkron özeti.": "Zusammenfassung der Plattformverbindung und Synchronisierung.",
    "Platform bağlantıları ve raporlar": "Plattformlinks und Berichte",
    "Platformlar": "Plattformen",
    "Platformlardan alınan son siparişler.": "Neueste Bestellungen von den Plattformen.",
    "Posta kodu": "Postleitzahl",
    "Posta kodu kontrol edilemedi.": "Postleitzahl konnte nicht überprüft werden.",
    "Profil": "Profil",
    "Profil yükleniyor": "Profil wird geladen",
    "Profili kaydet": "Profil speichern",
    "Programa katıl": "Nehmen Sie am Programm teil",
    "Prüfen Sie Ihren Posteingang für den Verifizierungslink.": "Prüfen Sie Ihren Posteingang für den Verifizierungslink.",
    "R2 dosya": "R2-Datei",
    "Raporlar": "Berichte",
    "RE-{yıl}-{sıra}": "RE-{Jahr}-{Bestellung}",
    "Referans": "Empfehlungen",
    "Referans bağlantıları": "Empfehlungsverknüpfungen",
    "Referans ve kazanç": "Empfehlungen & Guthaben",
    "Referans kodları, yönlendirilen müşteriler ve kullanım komisyonları.": "Empfehlungscodes, geworbene Kunden und Nutzungsprovisionen.",
    "Referans kodu": "Referenzcode",
    "Referans linki oluşturup yönlendirdiğiniz müşterilerin kullanım komisyonlarını takip edin.": "Erstellen Sie einen Referenzlink und verfolgen Sie die Nutzungsprovisionen der von Ihnen geworbenen Kunden.",
    "Referans linkiniz": "Ihr Referenzlink",
    "Retoure / iade": "Retoure / iade",
    "Rol kapsamı": "Rollenumfang",
    "Rol sistemi aktif": "Rollensystem aktiv",
    "S3 ortamı": "S3-Umgebung",
    "Satıcı": "Verkäufer",
    "Satın al": "kaufen",
    "Satın alınabilir ürün yok.": "Es sind keine Artikel zum Kauf verfügbar.",
    "Satın alma": "Einkauf",
    "Satın alma toplamı": "Kaufsumme",
    "Satın alma yok.": "Keine Käufe.",
    "satır": "Linie",
    "Satır değişiklikleri kaydedildiğinde PDF yeniden üretilir ve bağlı komisyon tutarları güncellenir.": "Wenn Zeilenänderungen gespeichert werden, wird das PDF neu generiert und die Affiliate-Provisionsbeträge werden aktualisiert.",
    "Satır ekle": "Zeile hinzufügen",
    "Satır notu": "Linernote",
    "Satırı sil": "Zeile löschen",
    "Satırlar": "Sie verkaufen",
    "Seçilen müşteri için ürün bazlı özel fiyatları düzenleyin.": "Bearbeiten Sie produktbasierte Sonderpreise für den ausgewählten Kunden.",
    "Senkron durumu": "Synchroner Status",
    "Senkron sipariş": "Synchrone Reihenfolge",
    "Sepete satır ekle": "Zeile zum Warenkorb hinzufügen",
    "Shopify checkout bağlantılı": "Shopify-Checkout verlinkt",
    "Shopify gönderim durumu": "Shopify-Versandstatus",
    "Shopify mesajı": "Shopify-Nachricht",
    "Shopify ödeme öncesi KDV davranışı Shopify checkout tarafıyla birlikte incelenecek.": "Das Shopify-Vorauszahlungs-Mehrwertsteuerverhalten wird mit der Shopify-Checkout-Seite überprüft.",
    "Shipment ID": "Shipment ID",
    "Sıfırla": "zurücksetzen",
    "Sınırlı müşteri görünümü": "Eingeschränkte Kundensicht",
    "sipariş": "Befehl",
    "Sipariş": "Befehl",
    "Sipariş bilgisi": "Bestellinformationen",
    "Sipariş bulunamadı": "Bestellung nicht gefunden",
    "Sipariş detayı açılamadı": "Bestelldetails konnten nicht geöffnet werden",
    "Sipariş detayı yükleniyor": "Bestelldetails werden geladen",
    "Sipariş faturası": "Rechnung bestellen",
    "Sipariş listesi": "Bestellliste",
    "Sipariş no": "Bestell-Nr.",
    "Sipariş sayısı": "Anzahl der Bestellungen",
    "Sipariş seçerek veya manuel adres girerek etiket üretin.": "Erstellen Sie Etiketten, indem Sie eine Bestellung auswählen oder eine Adresse manuell eingeben.",
    "Sipariş seçin": "Bestellung auswählen",
    "Sipariş senkron servisi Cloudflare içine alınmış durumda.": "Der Bestellsynchronisierungsdienst ist in Cloudflare integriert.",
    "Sipariş senkronu ve platform servis durumu.": "Auftragssynchronisierung und Plattformdienststatus.",
    "Sipariş ve gönderi operasyonları": "Bestell- und Versandvorgänge",
    "Sipariş ve gönderi yönetimi": "Auftrags- und Versandverwaltung",
    "Sipariş verisi": "Bestelldaten",
    "Sipariş yok.": "Keine Bestellung.",
    "Siparişler": "Bestellungen",
    "Siparişler yükleniyor": "Bestellungen werden geladen",
    "Siparişlere dön": "Zurück zu den Bestellungen",
    "Siparişleri al": "Bestellungen entgegennehmen",
    "Siparişleri görüntüle": "Bestellungen ansehen",
    "siparişno": "Bestellnummer",
    "Siparişten veya manuel adresten gönderi oluşturun.": "Erstellen Sie eine Sendung aus einer Bestellung oder einer manuellen Adresse.",
    "Sistemde kayıtlı çıktı": "Ausgabe im System gespeichert",
    "Sistemdeki sipariş kayıtları.": "Bestelldatensätze im System.",
    "Site adı": "Site-Name",
    "Son 24 saat": "Letzte 24 Stunden",
    "Son 7 gün": "letzten 7 Tage",
    "Son denetim": "Letzte Inspektion",
    "Son destek talepleri": "Aktuelle Supportanfragen",
    "Son giriş": "letzte Anmeldung",
    "Son giriş:": "Letzter Eintrag:",
    "Son gönderiler": "Neueste Sendungen",
    "Son hareket": "letzter Zug",
    "Son hareketler": "letzte Bewegungen",
    "Son hata kayıtları": "Aktuelle Fehlerprotokolle",
    "Son carrier event": "Letztes Carrier-Ereignis",
    "Son güncelleme": "Letzte Aktualisierung",
    "Son kayıt": "letzte Aufnahme",
    "Son kayıtlar": "Neueste Aufzeichnungen",
    "Son kaynak etiketleri": "Neueste Quell-Labels",
    "Son senkron": "letzte Synchronisierung",
    "Son siparişler": "Letzte Bestellungen",
    "Sonra bakılacak notlar": "Notizen zur späteren Betrachtung",
    "Standart KDV": "Standard-Mehrwertsteuer",
    "straße": "straße",
    "Süresi biten": "Abgelaufen",
    "Süresi biten etiketler için": "Für abgelaufene Labels",
    "Süresi bitmiş etiketler": "Abgelaufene Etiketten",
    "Sürüm": "Version",
    "Sürüm geçmişi, dağıtım versiyonu ve son ürün değişiklikleri.": "Versionsverlauf, Deployment-Version und aktuelle Produktänderungen verfolgen.",
    "Sürüm Notları": "Release Notes",
    "Mevcut Ürün Sürümü": "Aktuelle Produktversion",
    "Zaman Çizelgesi Kayıtları": "Timeline-Einträge",
    "Son Sürüm": "Neueste Version",
    "Mevcut sürüm geçmişi aynı eski yapıdan okunur; yeni kayıtlar son sürümden devam eder.": "Der aktuelle Versionsverlauf wird aus derselben alten Struktur gelesen; neue Einträge setzen bei der neuesten Version fort.",
    "şehir": "Stadt",
    "Şehir": "Stadt",
    "Şehir kontrol ediliyor": "Die Stadt wird kontrolliert",
    "Şifre": "Passwort",
    "Şifre tekrar": "Passwort erneut eingeben",
    "Şifreli alanlar boş bırakılırsa mevcut kayıt korunur.": "Wenn verschlüsselte Felder leer bleiben, bleibt der vorhandene Datensatz erhalten.",
    "Şifreyi güncelle": "Passwort aktualisieren",
    "Şu anda kullanıma hazır": "Jetzt einsatzbereit",
    "Stok kaynak etiketi void durumunda.": "Quelllabel ist void.",
    "Stok kaynaklarında status=void olan etiketler. Status offen grubu teslim edildi veya yolda sinyali olmayan açık DHL bildirimlerini ayrı gösterir.": "Quelllabels mit status=void. Die Gruppe Status offen zeigt offene DHL-Meldungen, die weder zugestellt noch unterwegs sind.",
    "Status offen": "Status offen",
    "Takip API": "Tracking-API",
    "Takip": "Tracking",
    "Takip API açılamadı": "Die Tracking-API konnte nicht geöffnet werden",
    "Takip API durumu yükleniyor": "Der Tracking-API-Status wird geladen",
    "Takip başarılı": "Tracking erfolgreich",
    "Takip bekleyen": "bis zur Nachverfolgung",
    "Takip geri yazma": "Folge zurück schreibe zurück",
    "Takip hatalı": "Die Sendungsverfolgung ist falsch",
    "Takip hatası": "Tracking-Fehler",
    "Takip mesajı": "Folgenachricht",
    "Takip no": "Tracking-Nummer",
    "Takip no, sipariş no veya alıcı ara": "Suchen Sie nach Tracking-Nr., Bestell-Nr. oder Empfänger",
    "Takip performansı": "Tracking-Leistung",
    "Takip senkronu": "Tracking-Synchronisierung",
    "Takip ve gönderi performansı": "Sendungsverfolgung und Versandleistung",
    "Takip zamanı": "Zeiterfassung",
    "Taşıma sonrası müşteri hesabı hazırlık adımları.": "Schritte zur Vorbereitung des Kundenkontos nach der Migration.",
    "Taşıyıcı": "Träger",
    "Taşıyıcı kontrolü": "Carrier-Prüfung",
    "Taşıyıcı kontrolünde sorunlu işaretlenen etiketler.": "Etiketten, die unter der Kontrolle des Spediteurs als problematisch gekennzeichnet wurden.",
    "Tek adres kutusu": "einzelnes Adressfeld",
    "Teknik detay": "Technische Details",
    "Teknik sorun": "technisches Problem",
    "Tekrar hoş geldin": "Willkommen zurück",
    "Temiz / açık": "klar/klar",
    "Teslim edildi": "Zugestellt",
    "Teslim sinyali": "Kapitulationssignal",
    "Telafi": "Kompensation",
    "Telafi mesajı": "Kompensationsmeldung",
    "Toplam adet": "Gesamtmenge",
    "Toplam void": "Void gesamt",
    "Toplam hesap": "Gesamtkonto",
    "Toplam: EUR": "Spitzenlamm: EUR",
    "Toplu manuel import": "Manueller Massenimport",
    "Tracking sync": "Tracking-Synchronisierung",
    "Tüketici anahtarı": "Consumer Key",
    "Tüketici gizli anahtarı": "Consumer Secret",
    "Tüketilen": "verbraucht",
    "Tüm takip senkronları": "Alle folgen den Synchronisierungen",
    "Tümü": "Alle",
    "Uygulama içinde oluşan müşteri ve admin hata referansları.": "Verweise auf Kunden- und Administratorfehler, die innerhalb der Anwendung auftreten.",
    "ülke": "Land",
    "Ülke": "Land",
    "Ürün": "Produkt",
    "Ürün adı": "Produktname",
    "Ürün bilgileri": "Produktinformationen",
    "Ürün seçin": "Produkt auswählen",
    "Ürün, taşıyıcı, ağırlık ve baz fiyat bilgileri.": "Informationen zu Produkt, Träger, Gewicht und Grundpreis.",
    "Ürünler": "Produkte",
    "Ürünü seçin ve bir veya daha fazla kaynak PDF yükleyin.": "Wählen Sie das Produkt aus und laden Sie ein oder mehrere Quell-PDFs hoch.",
    "Filtrelerden Status offen seçildiğinde teslim edildi veya yolda olmayan açık DHL bildirimli etiketler listelenir. Not, kontrol sonucu ve zamanlar için Detay butonunu kullanın.": "Wählen Sie Status offen, um Labels mit offenen DHL-Meldungen zu listen, die weder zugestellt noch unterwegs sind. Für Notizen, Prüfergebnisse und Zeitpunkte verwenden Sie Details.",
    "Kaynak dosya": "Quelldatei",
    "Kaynak ID": "Quell-ID",
    "Kullanıma aç": "Zur Nutzung freigeben",
    "Sorun / not": "Problem / Notiz",
    "Void kaynak etiketleri": "Void-Quelllabels",
    "Yedek etiket": "Ersatzlabel",
    "Yüklendi": "Hochgeladen",
    "Atandı": "Zugewiesen",
    "Varsayılan yap": "als Standard festlegen",
    "Vazgeç": "Abbrechen",
    "Vergi no": "Steuernummer",
    "Vergi oranı": "Steuersatz",
    "Veri kaynağı": "Datenquelle",
    "Versand- und Logistikdienstleistung": "Versand- und Logistikdienstleistung",
    "Video linki admin ortam değişkenine eklendiğinde burada açılacak.": "Wenn der Videolink zur Admin-Umgebungsvariablen hinzugefügt wird, wird er hier geöffnet.",
    "Videoyu aç": "Video öffnen",
    "Vite production derlemesi geçiyor": "Die Kompilierung der Vite-Produktion ist in Bearbeitung",
    "Void gönderiler ve bağlı etiketlerin güncel konumu.": "Aktueller Stand stornierter Sendungen und verknüpfter Labels.",
    "Wenn ein Verifizierungslink gesendet wurde, finden Sie ihn im Posteingang.": "Wenn ein Verifizierungslink gesendet wurde, finden Sie ihn im Posteingang.",
    "Yazdırıldı": "Gedruckt",
    "Yazdırılma/Gönderim": "Drucken/Versenden",
    "Yeni ekip üyesi": "neues Teammitglied",
    "Yeni mağaza": "neuer Laden",
    "Yeni müşteri": "neuer Kunde",
    "Yeni plan": "neuer Plan",
    "Yeni Sipariş Oluştur": "Neue Bestellung erstellen",
    "Yeni şifre": "Neues Passwort",
    "Yeni şifre tekrar": "Nochmals neues Passwort",
    "Yeni ürün": "neues Produkt",
    "Yeniden bağla": "wieder verbinden",
    "Yönetim": "Verwaltung",
    "Yolda": "Unterwegs",
    "Yönlendirilen": "gerichtet",
    "Yönlendirilen müşteriler": "Empfohlene Kunden",
    "Yükle": "Herunterladen",
    "Yükleme": "Laden",
    "Yüklenen ve müşterilere atanan son kaynak etiketleri.": "Neueste Quell-Labels hochgeladen und Kunden zugewiesen.",
    "Yükleniyor": "Laden",
    "Yüksek": "Hoch",
    "ZIP export": "ZIP-Export",
    "ZIP paket": "ZIP-Paket",
    "Shopware 6 Admin API ile siparişlerinizi alın ve oluşturulan takip numaralarını doğru teslimata geri yazın.": "Importieren Sie Ihre Bestellungen über die Shopware 6 Admin API und schreiben Sie die erzeugten Sendungsnummern in die richtige Lieferung zurück.",
    "Shopware mağazanızın ana adresi. /api eklemeyin.": "Die Basis-URL Ihres Shopware-Shops. Fügen Sie /api nicht hinzu.",
    "Aynı entegrasyona ait Secret Access Key. Bu değer ekranda tekrar gösterilmez.": "Der Secret Access Key derselben Integration. Dieser Wert wird nicht erneut angezeigt.",
    "Shopware 6 mağaza URL'si": "Shopware 6 Shop-URL",
    "Sipariş okuma ve teslimat güncelleme yetkisi": "Berechtigung zum Lesen von Bestellungen und Aktualisieren von Lieferungen",
    "Shopware yönetiminde KenPost için bir entegrasyon oluşturun.": "Erstellen Sie in der Shopware-Administration eine Integration für KenPost.",
    "Bağlantı doğrulandıktan sonra 30 dakikalık sipariş senkronunu başlatın.": "Starten Sie nach erfolgreicher Verbindungsprüfung die Bestellsynchronisierung im 30-Minuten-Takt.",
    "Shopware mağazasını bağla": "Shopware-Shop verbinden",
    "Shopware mağaza URL": "Shopware Shop-URL",
    "Shopware bağlantısı doğrulanamadı.": "Die Shopware-Verbindung konnte nicht geprüft werden.",
    "Takip sonrası gönderildi yap": "Nach Eintragen der Sendungsnummer als versendet markieren"
  }
};
